import { __awaiter, __generator, __assign, __spreadArray, __makeTemplateObject } from 'tslib';
import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useQuery } from '@apollo/client';
import { colorPalette, Advantage, Button, Link } from '@next-common/mui';
import { SvgImg } from '@next-common/shared-svg';
import didomiModule from '@next-common/didomi';
import CookieIcon from '@mui/icons-material/CookieOutlined';
import { AccordionMui, colorPalette as colorPalette$1 } from '@next-common/material-ui';
import { Check } from '@next-common/material-ui-icons';
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';
import Card$1 from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Divider from '@mui/material/Divider';
import { makeStyles } from '@material-ui/core';
import CardGiftcardOutlined from '@mui/icons-material/CardGiftcardOutlined';
import CasinoOutlined from '@mui/icons-material/CasinoOutlined';
import LocalOfferOutlined from '@mui/icons-material/LocalOfferOutlined';
import LocalShippingOutlined from '@mui/icons-material/LocalShippingOutlined';
import PercentOutlined from '@mui/icons-material/PercentOutlined';
import { isPast, subDays, format } from 'date-fns';
import { fr } from 'date-fns/locale';
import ArrowForwardOutlined from '@mui/icons-material/ArrowForwardOutlined';
import gql from 'graphql-tag';
import { useRouter } from 'next/router';
import { getLogger } from '@next-common/logger';

var NAME = 'crewPartnerModal';
var URL_PARTNER_PARAM = {
    name: 'partner',
};
var URL_PROMOTION_ID_PARAM = {
    name: 'promotionId',
};
var URL_LOAD_MODAL_PARAM = {
    name: 'loadCrewModal',
};
var URL_STEP_PARTNER_PARAM = {
    name: 'step',
};
var URL_P_PARAM = {
    name: 'p',
};
var STEPS = { PARTNER_MODAL: 1, EXTENSION_MODAL: 2, PARTNER_SUCCESS_MODAL: 3, PARTNER_SUCCESS_MODAL_FINAL: 4 };
// Labels
var connectButtonLabel = 'Se connecter';
var registerButtonLabel = "S'inscrire";
var offerTitleLabel = 'Après traitement, vous receverez votre cashback sous';
var offerTitleBookingLabel = 'Après traitement, vous receverez vos Rakuten Points sous';
var infoUrl = 'https://help.fr.shopping.rakuten.net/hc/fr/articles/8516494969746-Mon-remboursement-en-Rakuten-Points-n-appara%C3%AEt-pas-ou-a-disparu-sur-Mon-Compte-pourquoi-';
var offerDescLabel = (React.createElement("span", null,
    "En attendant, il appara\u00EEtra",
    React.createElement("b", null, " dans quelques jours "),
    "avec le statut",
    React.createElement("b", null, " \u201CEn attente\u201D "),
    "dans votre espace Club R."));
var offerDescBookingLabel = (React.createElement("span", null,
    "En attendant, ils appara\u00EEtront",
    React.createElement("b", null, " dans quelques jours "),
    "avec le statut",
    React.createElement("b", null, " \u201CEn attente\u201D "),
    "dans votre espace Club R."));
var multiCommissionLabel = "Jusqu'à ";
var partnerModalActionLabel = 'J\'en profite';
// Param names
var partnerParamName = 'partner';
var stepParamName = 'step';
var CHANNEL = {
    APPS_IOS: 1,
    APPS_ANDROID: 2,
    MOBILE: 3,
    DESKTOP: 4,
};
var crewQuestions = ['Comment ça marche ?', 'Délais de remboursement', 'Comment profiter du Club R'];
var crewBookingQuestions = ['Comment ça marche ?', 'Délais de reception des points', 'Comment profiter du Club R'];
var crewAnswers = {
    firstAnswerAuth: [
        'Prendre connaissance des conditions particulières',
        'Cliquez sur le bouton “Se connecter” ou “S’inscrire” ci-dessous',
        'Acceptez tous les cookies sur Rakuten et le site partenaire',
        'Faites vos achats sur le site partenaire',
        'Gagnez des euros sur vos achats et utilisez les sur Rakuten',
    ],
    firstAnswerNotAuth: [
        'Prendre connaissance des conditions particulières',
        'Inscrivez-vous gratuitement au Club R avec le bouton “J’en profite” ci-dessous',
        'Acceptez tous les cookies sur Rakuten et le site partenaire',
        'Faites vos achats sur le site partenaire',
        'Gagnez des euros sur vos achats et utilisez les sur Rakuten',
    ],
    profitAnswer: [
        {
            id: 0,
            title: 'étape 1',
            sub: 'Devenez membre du Club R en cliquant sur “j’en profite”',
        },
        {
            id: 1,
            title: 'étape 2',
            sub: 'Cumulez des euros à chacun de vos achats',
        },
        {
            id: 2,
            title: 'étape 3',
            sub: 'Utilisez vos euros sur le site Rakuten',
        },
    ],
};
var crewBookingAnswers = {
    firstAnswerAuth: [
        'Prendre connaissance des conditions particulières',
        'Cliquez sur le bouton “J’en profite” ci-dessous',
        'Acceptez tous les cookies sur Rakuten et le site partenaire',
        'Faites vos achats sur le site partenaire',
        'Gagnez des Rakuten Points sur vos achats et utilisez les sur Rakuten',
    ],
    firstAnswerNotAuth: [
        'Prendre connaissance des conditions particulières',
        'Inscrivez-vous gratuitement au Club R avec le bouton “J’en profite” ci-dessous',
        'Acceptez tous les cookies sur Rakuten et le site partenaire',
        'Faites vos achats sur le site partenaire',
        'Gagnez des Rakuten Points sur vos achats et utilisez les sur Rakuten',
    ],
    profitAnswer: [
        {
            id: 0,
            title: 'étape 1',
            sub: 'Devenez membre du Club R en cliquant sur “j’en profite”',
        },
        {
            id: 1,
            title: 'étape 2',
            sub: 'Cumulez des euros à chacun de vos achats',
        },
        {
            id: 2,
            title: 'étape 3',
            sub: 'Utilisez vos euros sur le site Rakuten',
        },
    ],
};
var postAnswers = {
    firstAnswer: 'La validation du cashback est effectuée par le marchand, ' + "le temps d'attente est donc indépendant de notre volonté. ",
    secondAnswer: 'Si vous retournez vos produits ou si vous n’avez pas ' +
        'suivi les conditions fixées par le partenaire pour profiter du cashback il peut vous être refusé.',
};
var postBookingAnswers = {
    firstAnswer: 'La validation de l’offre est effectuée par le marchand, ' + "le temps d'attente est donc indépendant de notre volonté. ",
    secondAnswer: 'Si vous retournez vos produits ou si vous n’avez pas ' +
        'suivi les conditions fixées par le partenaire pour profiter de l’offre, ils peuvent vous être refusés.',
};

var constants = /*#__PURE__*/Object.freeze({
  __proto__: null,
  NAME: NAME,
  URL_PARTNER_PARAM: URL_PARTNER_PARAM,
  URL_PROMOTION_ID_PARAM: URL_PROMOTION_ID_PARAM,
  URL_LOAD_MODAL_PARAM: URL_LOAD_MODAL_PARAM,
  URL_STEP_PARTNER_PARAM: URL_STEP_PARTNER_PARAM,
  URL_P_PARAM: URL_P_PARAM,
  STEPS: STEPS,
  connectButtonLabel: connectButtonLabel,
  registerButtonLabel: registerButtonLabel,
  offerTitleLabel: offerTitleLabel,
  offerTitleBookingLabel: offerTitleBookingLabel,
  infoUrl: infoUrl,
  offerDescLabel: offerDescLabel,
  offerDescBookingLabel: offerDescBookingLabel,
  multiCommissionLabel: multiCommissionLabel,
  partnerModalActionLabel: partnerModalActionLabel,
  partnerParamName: partnerParamName,
  stepParamName: stepParamName,
  CHANNEL: CHANNEL,
  crewQuestions: crewQuestions,
  crewBookingQuestions: crewBookingQuestions,
  crewAnswers: crewAnswers,
  crewBookingAnswers: crewBookingAnswers,
  postAnswers: postAnswers,
  postBookingAnswers: postBookingAnswers
});

var s$6 = {"container":"_f-container-5c463b","buttonContainer":"_f-buttonContainer-2540ca","whiteButtonWrapper":"_f-whiteButtonWrapper-990e06","mr10":"_f-mr10-10d678","whiteButton":"_f-whiteButton-9b97a5","button":"_f-button-ce0f2a","all":"_f-all-2365f0","redButton":"_f-redButton-8da14b","redButtonWrapper":"_f-redButtonWrapper-ee01b1","redButtonOnly":"_f-redButtonOnly-057367","blockSeparator":"_f-blockSeparator-103d6a","separator":"_f-separator-8ca174","title":"_f-title-7caef8","description":"_f-description-277153","bonsavoirText":"_f-bonsavoirText-07bd25","recompenseContainer":"_f-recompenseContainer-0a4d8e","logo":"_f-logo-007f29","scrollHeader":"_f-scrollHeader-a08231","category":"_f-category-634e98","fadeIn":"_f-fadeIn-97ee13","showContainer":"_f-showContainer-d2c07a","show":"_f-show-8905ca","externalLinkicon":"_f-externalLinkicon-c97f3a","secondButtonLabelRegisterDesktop":"_f-secondButtonLabelRegisterDesktop-c6c2bb","accordionContainer":"_f-accordionContainer-031b36","accordion":"_f-accordion-28170c","accordionItemContainer":"_f-accordionItemContainer-f390c2","externalLinkContainer":"_f-externalLinkContainer-7f8ecc","externalLinkText":"_f-externalLinkText-752e71","chevron":"_f-chevron-35e76b"};

var CrewPartnerModalFooter = function (_a) {
    var firstButton = _a.firstButton, secondButton = _a.secondButton;
    return secondButton ? (React.createElement("div", { className: s$6.buttonContainer },
        React.createElement("div", { className: "".concat(s$6.whiteButtonWrapper, " ").concat(s$6.mr10) },
            React.createElement("button", { type: "button", className: "".concat(s$6.whiteButton, " ").concat(s$6.button), onClick: firstButton.buttonAction },
                firstButton.buttonLabel,
                firstButton.icon && React.createElement("div", { className: s$6.externalLinkicon }, firstButton.icon))),
        React.createElement("div", { className: s$6.redButtonWrapper },
            React.createElement("button", { type: "button", className: "".concat(s$6.redButton, " ").concat(s$6.button), onClick: secondButton.buttonAction },
                React.createElement("div", { className: s$6.secondButtonLabelRegisterDesktop },
                    secondButton.icon && React.createElement("div", { className: s$6.externalLinkicon }, secondButton.icon),
                    secondButton.buttonLabel))))) : (React.createElement("div", { className: s$6.buttonContainer },
        React.createElement("button", { type: "button", className: "".concat(s$6.redButton, " ").concat(s$6.button, " ").concat(s$6.redButtonOnly), onClick: firstButton.buttonAction },
            firstButton.buttonLabel,
            firstButton.icon && React.createElement("div", { className: s$6.externalLinkicon }, firstButton.icon))));
};

var BrandLogo = function (_a) {
    var imageUrl = _a.imageUrl, _b = _a.color, color = _b === void 0 ? colorPalette.white : _b;
    return (React.createElement("div", { className: s$6.logo, style: {
            backgroundColor: color,
        } },
        React.createElement("img", { src: imageUrl, alt: "logo" })));
};

var BrandScrollLogo = function (_a) {
    var show = _a.show, title = _a.title;
    var classNames = show ? [s$6.scrollHeader, s$6.fadeIn].join(' ') : s$6.scrollHeader;
    return (React.createElement("div", { className: classNames },
        React.createElement("h1", null, title)));
};

var Close = function (_a) {
    var _b = _a.viewbox, viewbox = _b === void 0 ? '0 0 32 32' : _b, width = _a.width, height = _a.height, _c = _a.fill, fill = _c === void 0 ? '#929292' : _c;
    return (React.createElement(SvgImg, { viewbox: viewbox, title: "icon close", width: width, height: height },
        React.createElement("g", { fill: fill, fillRule: "evenodd" },
            React.createElement("g", { id: "ic_close" },
                React.createElement("polygon", { id: "path-1", points: "27 6.45 25.55 5 16 14.55 6.45 5 5 6.45 14.55 16 5 25.55 6.45 27 16 17.45 25.55 27 27 25.55 17.45 16 27 6.45" })))));
};

var s$5 = {"popin":"_f-popin-cbc77f","overlay":"_f-overlay-2dec97","darkOverlay":"_f-darkOverlay-effff4","container":"_f-container-55be07","body":"_f-body-189491","fullWidthBody":"_f-fullWidthBody-aee62d","safariFullWidthBody":"_f-safariFullWidthBody-2ac63a","closeIcon":"_f-closeIcon-5e1300"};

var PopIn = function (_a) {
    var _b = _a.inputStyle, inputStyle = _b === void 0 ? {} : _b, _c = _a.inputBodyStyle, inputBodyStyle = _c === void 0 ? {} : _c, _d = _a.containerBodyStyle, containerBodyStyle = _d === void 0 ? {} : _d, _e = _a.withCloseIcon, withCloseIcon = _e === void 0 ? false : _e, _f = _a.isOpen, isOpen = _f === void 0 ? false : _f, onCloseCallBack = _a.onCloseCallBack, _g = _a.overlayClosable, overlayClosable = _g === void 0 ? true : _g, children = _a.children, _h = _a.withFullWidthBody, withFullWidthBody = _h === void 0 ? false : _h, _j = _a.darkBgModal, darkBgModal = _j === void 0 ? false : _j, dataQa = _a.dataQa;
    var _k = useState(!isOpen), isClosed = _k[0], setIsClosed = _k[1];
    var onCloseDefault = function (func) {
        document.querySelector('html').style.overflow = 'unset';
        setIsClosed(true);
        if (func) {
            func();
        }
    };
    var closePopIn = function () { return onCloseDefault(onCloseCallBack); };
    useEffect(function () {
        document.querySelector('html').style.overflow = 'hidden';
        return function () {
            document.querySelector('html').style.overflow = 'unset';
        };
    }, []);
    useEffect(function () {
        setIsClosed(!isOpen);
    }, [isOpen]);
    return (!isClosed && (React.createElement("div", { className: s$5.popin, style: inputStyle },
        React.createElement("div", { className: s$5.container, style: containerBodyStyle },
            React.createElement("div", { className: "".concat(s$5.overlay, " ").concat(darkBgModal ? s$5.darkOverlay : '', " "), onClick: function () {
                    if (overlayClosable) {
                        closePopIn();
                    }
                } }),
            React.createElement("div", { className: "".concat(s$5.body, " ").concat(withFullWidthBody ? s$5.fullWidthBody : ''), style: inputBodyStyle, "data-qa": dataQa !== null && dataQa !== void 0 ? dataQa : null },
                withCloseIcon && (React.createElement("a", { className: s$5.closeIcon, onClick: closePopIn },
                    React.createElement(Close, { width: "24px", height: "24px", fill: "#00000" }))),
                children)))));
};

var s$4 = {"modalContainer":"_f-modalContainer-442093","fullModalContainer":"_f-fullModalContainer-0ad129","footer":"_f-footer-827fe7"};

var FullScreenModal = function (_a) {
    var bodyRef = _a.bodyRef, modalOnCloseCallBack = _a.modalOnCloseCallBack, body = _a.body, footer = _a.footer, _b = _a.darkBgModal, darkBgModal = _b === void 0 ? false : _b, _c = _a.withCloseIcon, withCloseIcon = _c === void 0 ? true : _c;
    return (React.createElement(PopIn, { onCloseCallBack: modalOnCloseCallBack, isOpen: true, overlayClosable: true, withCloseIcon: withCloseIcon, withFullWidthBody: true, darkBgModal: darkBgModal },
        React.createElement("div", { ref: bodyRef, className: footer ? s$4.modalContainer : s$4.fullModalContainer }, body),
        footer && React.createElement("div", { className: s$4.footer }, footer)));
};

var ACTIONS;
(function (ACTIONS) {
    ACTIONS["INIT_CREW_PARTNER_MODAL"] = "crewPartnerModal/INIT_CREW_PARTNER_MODAL";
    ACTIONS["SHOW_CREW_PARTNER_MODAL"] = "crewPartnerModal/SHOW_CREW_PARTNER_MODAL";
    ACTIONS["INIT_ADBLOCK_DETECTION"] = "crewPartnerModal/INIT_ADBLOCK_DETECTION";
    ACTIONS["SHOW_EXTENSION_MODAL"] = "crewPartnerModal/SHOW_EXTENSION_MODAL";
    ACTIONS["SHOW_PARTNER_SUCCESS_MODAL"] = "crewPartnerModal/SHOW_PARTNER_SUCCESS_MODAL";
    ACTIONS["SHOW_PARTNER_SUCCESS_MODAL_FINAL"] = "crewPartnerModal/SHOW_PARTNER_SUCCESS_MODAL_FINAL";
    ACTIONS["FETCH_CREW_PARTNER_DATA_REQUEST"] = "crewPartnerModal/FETCH_CREW_PARTNER_DATA_REQUEST";
    ACTIONS["FETCH_CREW_PARTNER_DATA_SUCCESS"] = "crewPartnerModal/FETCH_CREW_PARTNER_DATA_SUCCESS";
    ACTIONS["FETCH_CREW_PARTNER_DATA_FAILURE"] = "crewPartnerModal/FETCH_CREW_PARTNER_DATA_FAILURE";
    ACTIONS["FETCH_CREW_PARTNER_AND_CODE_PROMO_DATA_REQUEST"] = "crewPartnerModal/FETCH_CREW_PARTNER_AND_CODE_PROMO_DATA_REQUEST";
    ACTIONS["FETCH_CREW_PARTNER_AND_CODE_PROMO_DATA_SUCCESS"] = "crewPartnerModal/FETCH_CREW_PARTNER_AND_CODE_PROMO_DATA_SUCCESS";
    ACTIONS["FETCH_CREW_PARTNER_AND_CODE_PROMO_DATA_FAILURE"] = "crewPartnerModal/FETCH_CREW_PARTNER_AND_CODE_PROMO_DATA_FAILURE";
    ACTIONS["CLEAR_PARTNER_DATA"] = "crewPartnerModal/CLEAR_PARTNER_DATA";
    ACTIONS["FETCH_USER_DATA_REQUEST"] = "crewPartnerModal/FETCH_USER_DATA_REQUEST";
    ACTIONS["FETCH_USER_DATA_SUCCESS"] = "crewPartnerModal/FETCH_USER_DATA_SUCCESS";
    ACTIONS["FETCH_USER_DATA_FAILURE"] = "crewPartnerModal/FETCH_USER_DATA_FAILURE";
})(ACTIONS || (ACTIONS = {}));
var actionTypes = ACTIONS;

var URLs = {
    partner: '/visuels/content-short/lucy/club-r-everywhere/partners/partner_',
    promo: '/restpublic/web/eshop/landing/'
};

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
var defaultAppTrackingId = 9143800;
var getParamByName = function (param) {
    if (typeof window !== 'undefined') {
        var params = new URLSearchParams(window.location.search);
        return params.get(param);
    }
    return null;
};
var formatPartnerName = function (partnerName) { return partnerName.replace(/'/g, ''); };
var getCookie = function (name) {
    var v = document.cookie.match("(^|;) ?".concat(name, "=([^;]*)(;|$)"));
    return v ? v[2] : null;
};
var getURLRedirectNAVParam = function () {
    var urlCheckPattern = /&redirectNAV=(.*)$/i;
    if (urlCheckPattern.exec(window.location.href)) {
        return decodeURIComponent(urlCheckPattern.exec(window.location.href)[1]);
    }
    return null;
};
var getURLRedirectParam = function () {
    var urlCheckPattern = /&redir=(.*)$/i;
    if (urlCheckPattern.exec(window.location.href)) {
        return urlCheckPattern.exec(window.location.href)[1];
    }
    return null;
};
var getTrackingParam = function (loadedTracking, md) {
    if (loadedTracking) {
        return loadedTracking;
    }
    var pmCookie = getCookie('pm');
    var urlSearchParams = new URLSearchParams(pmCookie);
    var lastTracking = urlSearchParams.get('lasttracking');
    if (md.isEmbeddedInBuyerApp) {
        var trackingFromUrl = getParamByName('t');
        return trackingFromUrl || lastTracking || defaultAppTrackingId;
    }
    return lastTracking;
};
var getChannelId = function (md) {
    if (md.isEmbeddedInBuyerApp && !md.iphone) {
        return CHANNEL.APPS_ANDROID;
    }
    if (md.isEmbeddedInBuyerApp && md.iphone) {
        return CHANNEL.APPS_IOS;
    }
    if (md.wsParams.isMobile) {
        return CHANNEL.MOBILE;
    }
    return CHANNEL.DESKTOP;
};
var getRedirectUrl = function (loadedData, partnerData, partnerUrl, userId, consentCookie, md) {
    // Base URL
    var url = partnerUrl || partnerData.link || getURLRedirectNAVParam() || (loadedData && loadedData.link);
    // User ID
    url += "&".concat(partnerData.user_id_parameter, "=").concat(userId);
    // Tracking
    url += '|';
    var tracking = getTrackingParam(loadedData === null || loadedData === void 0 ? void 0 : loadedData.tracking, md);
    if (tracking) {
        url += tracking;
    }
    // ProductID
    if (loadedData === null || loadedData === void 0 ? void 0 : loadedData.productID) {
        url += "|".concat(loadedData.productID);
    }
    // Si on vient de l'extension pour rediriger sur la bonne FP partenaire
    var redirectParam = getURLRedirectParam();
    if (redirectParam) {
        url += "&p=".concat(redirectParam);
    }
    // Consent Cookie
    if (consentCookie) {
        url += consentCookie;
    }
    url += "&channelId=".concat(getChannelId(md));
    return url;
};

var isAdblockDetected = function () { return __awaiter(void 0, void 0, void 0, function () {
    var googleAdUrl, isAdblockActive;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                googleAdUrl = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js';
                isAdblockActive = false;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, fetch(new Request(googleAdUrl)).catch(function () { isAdblockActive = true; })];
            case 2:
                _a.sent();
                return [3 /*break*/, 4];
            case 3:
                _a.sent();
                isAdblockActive = true;
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/, isAdblockActive];
        }
    });
}); };

var HOST = typeof window === 'undefined' ? 'http://seo-recette001.priceminister.lan:48088' : '';
var loadPartnerFromEvent = function (partner, promotionId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var params, hash, newUrl;
    return __generator(this, function (_a) {
        if (partner) {
            dispatch({
                type: actionTypes.SHOW_CREW_PARTNER_MODAL,
                payload: {
                    partner: partner,
                    promotionId: promotionId,
                    step: STEPS.PARTNER_MODAL,
                },
                loadedData: null,
            });
            params = new URLSearchParams(window.location.search);
            params.set(URL_PARTNER_PARAM.name, partner);
            if (promotionId) {
                params.set(URL_PROMOTION_ID_PARAM.name, promotionId);
            }
            hash = window.location.hash;
            newUrl = "".concat(window.location.protocol, "//").concat(window.location.host).concat(window.location.pathname, "?").concat(params.toString()).concat(hash.length > 1 ? hash : '');
            window.history.pushState({ path: newUrl }, '', newUrl);
        }
        return [2 /*return*/];
    });
}); }; };
var loadPartnerFromLink = function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var loadCrewModal, data, partner, promotionId, step;
    return __generator(this, function (_a) {
        loadCrewModal = getParamByName(URL_LOAD_MODAL_PARAM.name);
        if (loadCrewModal) {
            data = localStorage.getItem("crew-fp-modal-".concat(loadCrewModal));
            if (data) {
                data = JSON.parse(data);
                dispatch({
                    type: actionTypes.SHOW_CREW_PARTNER_MODAL,
                    payload: {
                        partner: data.partnerName,
                        promotionId: data.promotionId,
                        step: STEPS.PARTNER_SUCCESS_MODAL,
                        loadedData: {
                            link: data.link,
                            tracking: data.tracking,
                            productID: data.productID,
                            idCoupon: data.idCoupon,
                        },
                    },
                });
                return [2 /*return*/];
            }
        }
        partner = getParamByName(URL_PARTNER_PARAM.name) || getParamByName(URL_P_PARAM.name);
        promotionId = getParamByName(URL_PROMOTION_ID_PARAM.name) || getParamByName(URL_PROMOTION_ID_PARAM.name);
        step = getParamByName('step');
        if (partner) {
            dispatch({
                type: actionTypes.SHOW_CREW_PARTNER_MODAL,
                payload: {
                    partner: partner,
                    promotionId: promotionId,
                    step: step === '3' ? STEPS.PARTNER_SUCCESS_MODAL : STEPS.PARTNER_MODAL,
                },
                loadedData: null,
            });
        }
        return [2 /*return*/];
    });
}); };
var initCrewBtnListeners = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        document.querySelector('body').addEventListener('click', function (e) {
            var partnerBtn = e.target.closest('[data-popin]:not([data-productid])');
            if (partnerBtn) {
                e.preventDefault();
                var partnerName = partnerBtn.getAttribute('data-js');
                var promotionId = partnerBtn.getAttribute('data-promotion-id');
                document.dispatchEvent(new CustomEvent('CREW-MODAL-PARTNER', { detail: { partner: partnerName, promotionId: promotionId } }));
            }
        });
        return [2 /*return*/];
    });
}); };
var dispatchShowCrewPartnerModal = function (dispatch, partnerFPBtn, link) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        dispatch({
            type: actionTypes.SHOW_CREW_PARTNER_MODAL,
            payload: {
                partner: partnerFPBtn.getAttribute('data-js'),
                step: STEPS.PARTNER_MODAL,
                loadedData: {
                    link: link || partnerFPBtn.getAttribute('data-link'),
                    tracking: partnerFPBtn.getAttribute('data-tracking'),
                    productID: partnerFPBtn.getAttribute('data-productid'),
                    idCoupon: partnerFPBtn.getAttribute('data-id'),
                },
            },
        });
        return [2 /*return*/];
    });
}); };
var initFPCrewBtnListener = function (link, setProduct, setAdvertId) {
    return function (dispatch) {
        var url = window.location.href;
        var params = new URL(url).searchParams;
        var productId = params.get('productId');
        var advertId = params.get('advertId');
        var path = new URL(url).pathname;
        var isProductPage = path.includes('/offer/buy') || path.includes('/mfp');
        if (productId && advertId && !isProductPage) {
            setProduct(Number(productId));
            return setAdvertId(Number(advertId));
        }
        document.querySelector('body').addEventListener('click', function (e) {
            var partnerFPBtnContainer = e.target.closest('.buyBoxCta');
            if (partnerFPBtnContainer) {
                var advertCntnr = partnerFPBtnContainer.querySelector('[data-advert-id]');
                var partnerFPBtn = partnerFPBtnContainer.querySelector('[data-popin][data-productid]');
                if (advertCntnr) {
                    setAdvertId(Number(advertCntnr.getAttribute('data-advert-id')));
                }
                if (partnerFPBtn) {
                    e.preventDefault();
                    setProduct(Number(partnerFPBtn.getAttribute('data-productid')));
                    dispatchShowCrewPartnerModal(dispatch, partnerFPBtn, link);
                }
            }
            else {
                var advertCntnr = e.target.closest('.itemListCrew[data-advert-id]');
                var advertvis = e.target.closest('.MuiBox-root[advert-crew-id]');
                var advertvis2 = e.target.closest('.V5Box-root[advert-crew-id]');
                var partnerFPBtn = e.target.closest('.crew-cta[data-popin][data-productid]');
                if (advertvis) {
                    setAdvertId(Number(advertvis.getAttribute('advert-crew-id')));
                }
                if (advertvis2) {
                    setAdvertId(Number(advertvis2.getAttribute('advert-crew-id')));
                }
                if (advertCntnr) {
                    setAdvertId(Number(advertCntnr.getAttribute('data-advert-id')));
                }
                if (partnerFPBtn) {
                    e.preventDefault();
                    setProduct(Number(partnerFPBtn.getAttribute('data-productid')));
                    dispatchShowCrewPartnerModal(dispatch, partnerFPBtn, link);
                }
            }
        });
    };
};
var openRedirectModal = function (partnerName, loadedData, redirectUrl) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var params, hash, newUrl;
    return __generator(this, function (_a) {
        params = new URLSearchParams(window.location.search);
        if (loadedData) {
            localStorage.setItem("crew-fp-modal-".concat(partnerName, "-").concat(loadedData.productID), JSON.stringify(__assign(__assign({}, loadedData), { partnerName: partnerName })));
            params.delete(partnerParamName);
            params.delete(stepParamName);
            params.set(URL_LOAD_MODAL_PARAM.name, "".concat(partnerName, "-").concat(loadedData.productID));
        }
        else {
            params.set(partnerParamName, partnerName);
            params.set(stepParamName, STEPS.PARTNER_SUCCESS_MODAL.toString());
            params.delete(URL_LOAD_MODAL_PARAM.name);
        }
        hash = window.location.hash;
        newUrl = "".concat(window.location.protocol, "//").concat(window.location.host, "/activation-cashback?partner=").concat(partnerName).concat(hash.length > 1 ? hash : '').concat(redirectUrl ? "&redirectUrl=".concat(redirectUrl) : '');
        window.open(newUrl, '_blank');
        dispatch({ type: actionTypes.SHOW_PARTNER_SUCCESS_MODAL_FINAL });
        return [2 /*return*/];
    });
}); }; };
var checkAdBlock = function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var isAdblockActive;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, isAdblockDetected()];
            case 1:
                isAdblockActive = _a.sent();
                dispatch({
                    type: actionTypes.INIT_ADBLOCK_DETECTION,
                    payload: isAdblockActive,
                });
                return [2 /*return*/];
        }
    });
}); };
var fetchCrewPartnerData = function (partnerName) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        dispatch({ type: actionTypes.FETCH_CREW_PARTNER_DATA_REQUEST });
        fetch("".concat(URLs.partner).concat(partnerName, ".json"), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(function (response) { return response.json(); })
            .then(function (data) {
            dispatch({
                type: actionTypes.FETCH_CREW_PARTNER_DATA_SUCCESS,
                payload: data[partnerName],
            });
        })
            .catch(function (err) {
            dispatch({
                type: actionTypes.FETCH_CREW_PARTNER_DATA_FAILURE,
                payload: err.response && err.response.data,
            });
        });
        return [2 /*return*/];
    });
}); }; };
var fetchCrewPartnerDataWithCodePromoData = function (partnerName, promotionId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var partnerPromise, promotionsPromise;
    return __generator(this, function (_a) {
        dispatch({ type: actionTypes.FETCH_CREW_PARTNER_AND_CODE_PROMO_DATA_REQUEST });
        partnerPromise = fetch("".concat(URLs.partner).concat(partnerName, ".json"), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        }).then(function (partnerDataResponse) { return partnerDataResponse.json(); });
        promotionsPromise = fetch("".concat(HOST).concat(URLs.promo).concat(partnerName, "/info"), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        }).then(function (promotionsResponse) { return promotionsResponse.json(); });
        Promise.all([partnerPromise, promotionsPromise])
            .then(function (_a) {
            var partnerResult = _a[0], promotionsResult = _a[1];
            dispatch({
                type: actionTypes.FETCH_CREW_PARTNER_AND_CODE_PROMO_DATA_SUCCESS,
                payload: {
                    partnerData: partnerResult[partnerName],
                    promotionData: promotionsResult.promotions[promotionId],
                },
            });
        })
            .catch(function (err) {
            dispatch({
                type: actionTypes.FETCH_CREW_PARTNER_AND_CODE_PROMO_DATA_FAILURE,
                payload: err.response && err.response.data,
            });
        });
        return [2 /*return*/];
    });
}); }; };
var handleOnClose = function (isVisNextUrl) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var params, query, hash, newUrl;
    return __generator(this, function (_a) {
        if (!isVisNextUrl) {
            dispatch({
                type: actionTypes.CLEAR_PARTNER_DATA,
            });
        }
        params = new URLSearchParams(window.location.search);
        if (params.get(URL_PARTNER_PARAM.name) || params.get(URL_P_PARAM.name)) {
            params.delete(URL_PARTNER_PARAM.name);
            params.delete(URL_PROMOTION_ID_PARAM.name);
            params.delete(URL_P_PARAM.name);
            query = params.toString();
            hash = window.location.hash;
            newUrl = "".concat(window.location.protocol, "//").concat(window.location.host).concat(window.location.pathname).concat(query.length > 0 ? "?".concat(query) : '').concat(hash.length > 1 ? hash : '');
            window.history.pushState({ path: newUrl }, '', newUrl);
        }
        return [2 /*return*/];
    });
}); }; };
var buildRedirectUrl = function (partnerName, advertId, productId) {
    var params = new URLSearchParams(window.location.search);
    params.set('partner', partnerName);
    if (advertId)
        params.set('advertId', advertId);
    if (productId)
        params.set('productId', productId);
    return encodeURIComponent("".concat(window.location.pathname, "?").concat(params.toString()));
};
var handleRegister = function (partnerName, advertId, productId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        window.location.assign("/register?referer=crew&redirect_url=".concat(buildRedirectUrl(partnerName, advertId, productId)));
        return [2 /*return*/];
    });
}); };
var handleLogin = function (partnerName, advertId, productId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        window.location.assign("/connect?action=redirect&clubsubscription=true&url=".concat(buildRedirectUrl(partnerName, advertId, productId)));
        return [2 /*return*/];
    });
}); };
var sendATInternetEvent = function (page_1, props_1) {
    var args_1 = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args_1[_i - 2] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([page_1, props_1], args_1, true), void 0, function (page, props, chapter1, chapter3) {
        var tag, cleanProps_1;
        if (chapter1 === void 0) { chapter1 = 'crew'; }
        return __generator(this, function (_a) {
            if (window.ATInternet) {
                tag = new window.ATInternet.Tracker.Tag();
                tag.page.set({
                    name: page,
                    chapter1: chapter1,
                    level2: window.location.pathname.startsWith("/s/")
                        || window.location.pathname.startsWith("/search/")
                        ? 25 : window.location.pathname.startsWith('/affiliate/') ? 24 : undefined,
                    chapter3: chapter3,
                });
                cleanProps_1 = __assign({}, props);
                Object.keys(cleanProps_1).forEach(function (key) { return cleanProps_1[key] === undefined && delete cleanProps_1[key]; });
                tag.setProps(__assign({}, cleanProps_1), false);
                tag.dispatch();
            }
            return [2 /*return*/];
        });
    });
};

var actions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  loadPartnerFromEvent: loadPartnerFromEvent,
  loadPartnerFromLink: loadPartnerFromLink,
  initCrewBtnListeners: initCrewBtnListeners,
  initFPCrewBtnListener: initFPCrewBtnListener,
  openRedirectModal: openRedirectModal,
  checkAdBlock: checkAdBlock,
  fetchCrewPartnerData: fetchCrewPartnerData,
  fetchCrewPartnerDataWithCodePromoData: fetchCrewPartnerDataWithCodePromoData,
  handleOnClose: handleOnClose,
  handleRegister: handleRegister,
  handleLogin: handleLogin,
  sendATInternetEvent: sendATInternetEvent
});

var s$3 = {"Alert":"_f-Alert-101320","Content":"_f-Content-4f2e19","Icon":"_f-Icon-6e3577","TitleText":"_f-TitleText-15c615","Title":"_f-Title-c38750","Link":"_f-Link-6bb295","LinkLabel":"_f-LinkLabel-547c2b"};

var iconStyle$1 = {
    color: colorPalette.lightBlue800,
    fontSize: 16,
};
var CookieCard = function (_a) {
    var isShowCashbackterm = _a.isShowCashbackterm;
    var handleClick = function () {
        var _a, _b;
        (_b = (_a = window === null || window === void 0 ? void 0 : window.Didomi) === null || _a === void 0 ? void 0 : _a.preferences) === null || _b === void 0 ? void 0 : _b.show();
    };
    return (React.createElement("div", { className: s$3.Alert },
        React.createElement("div", { className: s$3.Content },
            React.createElement("div", { className: s$3.Icon },
                React.createElement(CookieIcon, { style: iconStyle$1 })),
            React.createElement("div", { className: s$3.Title },
                "Pour profiter ",
                isShowCashbackterm ? "de l'offre" : "du cashback",
                ", il est imp\u00E9ratif d'accepter tous les cookies Rakuten.")),
        React.createElement("div", { className: s$3.Link, onClick: handleClick },
            React.createElement("div", { className: s$3.LinkLabel }, "Accepter les cookies"))));
};

var s$2 = {"accordionItemContainer":"_f-accordionItemContainer-f629bf","accrodionItemText":"_f-accrodionItemText-75a11f","listItemContainer":"_f-listItemContainer-2db82b","listItemWrapper":"_f-listItemWrapper-61531c","itemWrapper":"_f-itemWrapper-26d9ac","listItem":"_f-listItem-c51960","cardContainer":"_f-cardContainer-106d61","logoContainer":"_f-logoContainer-dc40c9","logo":"_f-logo-118755","textContainer":"_f-textContainer-344ec7","title":"_f-title-e060ff","duration":"_f-duration-e8b650","description":"_f-description-754b24","externalLinkContainer":"_f-externalLinkContainer-ea32eb","externalLinkText":"_f-externalLinkText-a4fc29","chevron":"_f-chevron-be42f7","containerItem":"_f-containerItem-fb15f3","containerPadding":"_f-containerPadding-f566c5","iconItem":"_f-iconItem-e5b948","separationBorder":"_f-separationBorder-34f89c","iconTitleWraper":"_f-iconTitleWraper-47cfc5","iconTitleWraperMargin":"_f-iconTitleWraperMargin-e3ab4b","iconContainer":"_f-iconContainer-006816","bigIcon":"_f-bigIcon-0795f7","titleRefund":"_f-titleRefund-f8e220","descriptionRefund":"_f-descriptionRefund-99f203","titleProfit":"_f-titleProfit-a0c3fa","descriptionProfit":"_f-descriptionProfit-89b0f7"};

var smallIconStyle = {
    color: colorPalette.white,
    fontSize: 10,
    verticalAlign: 'middle',
};
var iconStyle = {
    color: colorPalette.red600,
    fontSize: 16,
    verticalAlign: 'middle',
};
var AccordionItem = function (_a) {
    var title = _a.title, description = _a.description, _b = _a.isList, isList = _b === void 0 ? false : _b, Icon = _a.Icon, Icons = _a.Icons, _c = _a.hasHeader, hasHeader = _c === void 0 ? false : _c, children = _a.children;
    var displayItems = function () {
        if (isList && Array.isArray(description)) {
            var items = description === null || description === void 0 ? void 0 : description.reduce(function (acc, key, id) {
                var item = (React.createElement("div", { className: s$2.listItemContainer }, Icon ? (React.createElement("div", { className: "".concat(s$2.containerItem, " ").concat(id !== 0 && s$2.containerPadding) },
                    React.createElement("div", { className: s$2.iconItem },
                        React.createElement(Icon, { style: smallIconStyle })),
                    React.createElement("text", null, key))) : (React.createElement("li", { className: s$2.listItem }, key))));
                return __spreadArray(__spreadArray([], acc, true), [item], false);
            }, []);
            return (React.createElement("div", { className: s$2.listItemContainer }, Icon ? React.createElement("div", { className: s$2.itemWrapper }, items) : React.createElement("ul", { className: s$2.listItemWrapper }, items)));
        }
        if (hasHeader) {
            var hasSeparation_1 = description.length > 1;
            // @ts-expect-error description is considered as string array
            var items = description === null || description === void 0 ? void 0 : description.reduce(function (acc, key) {
                var item = (React.createElement("div", { key: key.id, className: "".concat(hasSeparation_1 && s$2.separationBorder) },
                    React.createElement("div", { className: "".concat(s$2.iconTitleWraper, " ").concat(key.id !== 0 && s$2.iconTitleWraperMargin, " ") },
                        React.createElement("div", { className: s$2.iconContainer }, key.id === 0 ? React.createElement(TimerOutlinedIcon, { style: iconStyle }) : React.createElement(Check, { style: iconStyle })),
                        React.createElement("text", { className: s$2.titleRefund }, key.title)),
                    React.createElement("text", { className: s$2.descriptionRefund }, key.sub)));
                return __spreadArray(__spreadArray([], acc, true), [item], false);
            }, []);
            return React.createElement("div", { className: "".concat(s$2.listItemContainer, " ").concat(s$2.itemWrapper) }, items);
        }
        if (Icons) {
            // @ts-expect-error description is considered as string array
            var items = description === null || description === void 0 ? void 0 : description.reduce(function (acc, key) {
                var BigIcon = Icons[key.id];
                var item = (React.createElement("div", { key: key.id },
                    React.createElement("div", { className: "".concat(s$2.iconTitleWraper, " ").concat(key.id !== 0 ? s$2.iconTitleWraperMargin : '', " ") },
                        React.createElement("div", { className: "".concat(s$2.iconContainer, " ").concat(s$2.bigIcon) },
                            React.createElement("img", { src: BigIcon })),
                        React.createElement("div", { style: { display: 'flex', flexDirection: 'column', flex: 1 } },
                            React.createElement("text", { className: s$2.titleProfit }, key.title),
                            React.createElement("text", { className: s$2.descriptionProfit }, key.sub)))));
                return __spreadArray(__spreadArray([], acc, true), [item], false);
            }, []);
            return React.createElement("div", { className: "".concat(s$2.listItemContainer, " ").concat(s$2.itemWrapper) }, items);
        }
        return (React.createElement("div", { className: s$2.accordionItemContainer },
            React.createElement("text", { className: s$2.accrodionItemText }, description)));
    };
    return (React.createElement(AccordionMui, { title: title, isLite: true },
        React.createElement(React.Fragment, null,
            displayItems(),
            children)));
};

var CrewPartnerContentModal = function (_a) {
    var _b, _c, _d, _e, _f;
    var partnerData = _a.partnerData, isAuthenticated = _a.isAuthenticated, v2 = _a.v2, userData = _a.userData, activationQuestions = _a.activationQuestions, activationAnswers = _a.activationAnswers, isHidden = _a.isHidden, titleRef = _a.titleRef, showV2 = _a.showV2, isCookieEnabled = _a.isCookieEnabled, isShowCashbackterm = _a.isShowCashbackterm;
    var partnerName = partnerData === null || partnerData === void 0 ? void 0 : partnerData.title;
    var multi = ((_b = partnerData === null || partnerData === void 0 ? void 0 : partnerData.cashback) === null || _b === void 0 ? void 0 : _b.multi) ? partnerData.cashback.multi : false;
    var boost = ((_c = partnerData === null || partnerData === void 0 ? void 0 : partnerData.cashback) === null || _c === void 0 ? void 0 : _c.boost) ? partnerData.cashback.boost : false;
    var isCustomerCrew = ((_d = userData === null || userData === void 0 ? void 0 : userData.crew) === null || _d === void 0 ? void 0 : _d.isCustomerCrew) ? userData.crew.isCustomerCrew : false;
    var _g = partnerData === null || partnerData === void 0 ? void 0 : partnerData.cashback, value = _g.value, type = _g.type;
    var Icons = [
        'https://fr.shopping.rakuten.com/visuels/0_next-common/crew-partner-modal/notes.png',
        'https://fr.shopping.rakuten.com/visuels/0_next-common/crew-partner-modal/bag.png',
        'https://fr.shopping.rakuten.com/visuels/0_next-common/crew-partner-modal/coin.png',
    ];
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { ref: titleRef, className: v2 && showV2 ? [s$6.show, s$6.showContainer].join(' ') : s$6.showContainer },
            React.createElement("div", { className: s$6.title }, partnerData.title),
            React.createElement("div", { className: s$6.description },
                "R\u00E9cuperez des ",
                isShowCashbackterm ? 'Rakuten Points' : 'euros',
                " en achetant sur ",
                partnerData.title)),
        React.createElement("div", { className: s$6.recompenseContainer },
            React.createElement(Advantage, { value: value, type: type, multi: multi, isShowCashbackterm: isShowCashbackterm, isCustomerCrew: !isCustomerCrew, boost: boost, partnerName: partnerName })),
        React.createElement("div", { className: s$6.container },
            React.createElement("div", { className: s$6.blockSeparator }),
            !isCookieEnabled && React.createElement(CookieCard, { isShowCashbackterm: isShowCashbackterm }),
            React.createElement("div", { className: s$6.blockSeparator }),
            !isHidden && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: s$6.bonsavoirText }, "Bon \u00E0 savoir"),
                React.createElement("div", { className: s$6.accordionContainer },
                    (!isAuthenticated || !((_e = userData === null || userData === void 0 ? void 0 : userData.priceClub) === null || _e === void 0 ? void 0 : _e.isSubscribed)) && (React.createElement("div", { className: s$6.accordionItemContainer },
                        React.createElement(AccordionItem, { title: activationQuestions[2], description: activationAnswers.profitAnswer, Icons: Icons }))),
                    isAuthenticated && !((_f = userData === null || userData === void 0 ? void 0 : userData.crew) === null || _f === void 0 ? void 0 : _f.hasMadeEnoughCrewPurshase) && (React.createElement("div", { className: s$6.accordionItemContainer },
                        React.createElement(AccordionItem, { title: activationQuestions[0], description: activationAnswers.firstAnswerAuth, isList: true, 
                            // @ts-expect-error ts-migrate(2739) FIXME: Type 'OverridableComponent<SvgIconTypeMap<{}, "svg... Remove this comment to see the full error message
                            Icon: Check }))),
                    !isAuthenticated && (React.createElement("div", { className: s$6.accordionItemContainer },
                        React.createElement(AccordionItem, { title: activationQuestions[0], description: activationAnswers.firstAnswerNotAuth, isList: true, 
                            // @ts-expect-error ts-migrate(2322) FIXME: Type 'OverridableComponent<SvgIconTypeMap<{}, "svg... Remove this comment to see the full error message
                            Icon: Check }))),
                    (partnerData === null || partnerData === void 0 ? void 0 : partnerData.conditions) && (React.createElement("div", { className: s$6.accordionItemContainer },
                        React.createElement(AccordionItem, { title: "Conditions particuli\u00E8res", description: partnerData.conditions, isList: true }))),
                    (partnerData === null || partnerData === void 0 ? void 0 : partnerData.category) === 'voyage' || (partnerData === null || partnerData === void 0 ? void 0 : partnerData.isLongReimbursement) ? (React.createElement("div", { className: s$6.accordionItemContainer },
                        React.createElement(AccordionItem, { title: activationQuestions[1], description: activationAnswers.longRefundAnswer, hasHeader: true }))) : (React.createElement("div", { className: s$6.accordionItemContainer },
                        React.createElement(AccordionItem, { title: activationQuestions[1], description: activationAnswers.refundAnswer, hasHeader: true })))))))));
};

var useStyles = makeStyles(function (theme) {
    var _a;
    return ({
        container: (_a = {
                margin: '16px'
            },
            _a[theme.breakpoints.up(768)] = {
                marginBottom: '116px',
            },
            _a),
        detailsContainer: {
            borderColor: "".concat(colorPalette$1.white, " !important"),
        },
        cardContainer: {
            borderColor: "".concat(colorPalette$1.gray900, " !important"),
            marginBottom: '16px',
        },
        titleContainer: {
            borderBottom: 'solid 1px',
            borderBottomColor: colorPalette$1.gray200,
            color: colorPalette$1.red800,
            display: 'flex',
            justifyContent: 'center',
            gap: '6px',
            fontWeight: 600,
            fontSize: '14px',
            paddingTop: '12px',
            paddingBottom: '12px',
        },
        descriptionContainer: {
            color: colorPalette$1.gray900,
            fontWeight: 600,
            fontSize: '14px',
            paddingBottom: '16px !important',
        },
        description: {
            maxHeight: '68px',
            overflow: 'hidden',
            display: '-webkit-box',
            '-webkit-box-orient': 'vertical',
            '-webkit-line-clamp': '4',
        },
        divider: {
            borderColor: colorPalette$1.gray200,
            margin: '16px 0 !important',
        },
        offer: {
            '& span': {
                fontWeight: 600,
                fontSize: '14px',
            },
            '& > div': {
                gap: '0px',
                paddingTop: '12px',
                flexDirection: 'column',
                '& > div': {
                    padding: '4px 0px',
                },
            },
        },
        cookieCardContainer: {
            marginTop: '12px',
        },
        textContainer: {
            '& span': {
                fontWeight: 600,
                fontSize: '14px',
            },
            '& > div': {
                marginTop: '12px',
                fontSize: '12px',
                color: colorPalette$1.gray700,
            },
        },
        expiration: {
            fontWeight: 600,
            textTransform: 'uppercase',
        },
        voucherContainer: {
            display: 'flex',
            marginTop: '16px',
            gap: '16px',
            '& > div': {
                flexGrow: '1',
                display: 'flex',
                '& > span': {
                    margin: 'auto',
                    marginLeft: '16px',
                    fontWeight: 700,
                    color: colorPalette$1.gray900,
                },
            },
            '& > button': {
                border: "1px solid ".concat(colorPalette$1.red800),
            },
        },
    });
});

var PromotionTypes = [
    {
        name: 'PROMOTION',
        label: 'Offre du moment',
        icon: function (props) { return React.createElement(PercentOutlined, __assign({}, props)); },
    },
    {
        name: 'VOUCHER',
        label: 'Code promo',
        icon: function (props) { return React.createElement(LocalOfferOutlined, __assign({}, props)); },
    },
    {
        name: 'FREE SHIPPING',
        label: 'Livraison gratuite',
        icon: function (props) { return React.createElement(LocalShippingOutlined, __assign({}, props)); },
    },
    {
        name: 'FREE ARTICLE',
        label: 'Cadeau offert',
        icon: function (props) { return React.createElement(CardGiftcardOutlined, __assign({}, props)); },
    },
    {
        name: 'CONTEST',
        label: 'Jeu concours',
        icon: function (props) { return React.createElement(CasinoOutlined, __assign({}, props)); },
    },
];

var toDateString = function (start, end) {
    var endDate = new Date(Date.parse(end));
    var startDate = new Date(Date.parse(start));
    var result = '';
    if (!isPast(new Date(end)) && isPast(subDays(new Date(end), 7))) {
        result = 'Expire bientôt';
    }
    else if (isPast(new Date(end))) {
        result = 'Expiré';
    }
    else if (startDate.getFullYear() === endDate.getFullYear()) {
        if (startDate.getMonth() === endDate.getMonth()) {
            if (startDate.getDay() === endDate.getDay()) {
                result = "Uniquement le ".concat(format(startDate, 'dd MMM yyyy', {
                    locale: fr,
                }));
            }
            else {
                result = "Du ".concat(format(startDate, 'dd', { locale: fr }), " au ").concat(format(endDate, 'dd MMM yyyy', { locale: fr }));
            }
        }
        else {
            result = "Du ".concat(format(startDate, 'dd MMM', { locale: fr }), " au ").concat(format(endDate, 'dd MMM yyyy', { locale: fr }));
        }
    }
    else {
        result = "Du ".concat(format(startDate, 'dd MMM yyyy', { locale: fr }), " au ").concat(format(endDate, 'dd MMM yyyy', { locale: fr }));
    }
    return result;
};
var CrewPromotionContentModal = function (_a) {
    var _b, _c, _d;
    var partnerData = _a.partnerData, promotionData = _a.promotionData, userData = _a.userData, titleRef = _a.titleRef, isCookieEnabled = _a.isCookieEnabled, isShowCashbackterm = _a.isShowCashbackterm;
    var classes = useStyles();
    var defaultPromotionData = PromotionTypes.find(function (p) { return p.name === promotionData.type; });
    var partnerName = partnerData === null || partnerData === void 0 ? void 0 : partnerData.title;
    var multi = ((_b = partnerData === null || partnerData === void 0 ? void 0 : partnerData.cashback) === null || _b === void 0 ? void 0 : _b.multi) ? partnerData.cashback.multi : false;
    var boost = ((_c = partnerData === null || partnerData === void 0 ? void 0 : partnerData.cashback) === null || _c === void 0 ? void 0 : _c.boost) ? partnerData.cashback.boost : false;
    var isCustomerCrew = ((_d = userData === null || userData === void 0 ? void 0 : userData.crew) === null || _d === void 0 ? void 0 : _d.isCustomerCrew) ? userData.crew.isCustomerCrew : false;
    var _e = partnerData === null || partnerData === void 0 ? void 0 : partnerData.cashback, value = _e.value, type = _e.type;
    var _f = useState(false), hasVoucherClicked = _f[0], setVoucherClicked = _f[1];
    return (React.createElement("div", { ref: titleRef, className: classes.container },
        React.createElement(Card$1, { variant: "outlined", className: classes.cardContainer },
            React.createElement(CardContent, { className: classes.titleContainer },
                defaultPromotionData.icon({ fontSize: 'small' }),
                " ",
                defaultPromotionData.label),
            React.createElement(CardContent, { className: classes.descriptionContainer },
                React.createElement("div", { className: classes.description }, promotionData.title.replace(/<[^>]*>?/gm, '')),
                promotionData.type === 'VOUCHER' && promotionData.code && (React.createElement("div", { className: classes.voucherContainer },
                    React.createElement(Card$1, { variant: "outlined" },
                        React.createElement("span", null, promotionData.code)),
                    React.createElement(Button, { variant: hasVoucherClicked ? 'outlined' : 'contained', onClick: function () {
                            navigator.clipboard.writeText(promotionData.code);
                            setVoucherClicked(true);
                        } },
                        ' ',
                        hasVoucherClicked ? 'Copié !' : 'Copier'))))),
        React.createElement(Card$1, { variant: "outlined", className: classes.detailsContainer },
            React.createElement("div", { className: classes.offer },
                React.createElement("span", null, "Offre cumul\u00E9e"),
                React.createElement(Advantage, { size: "S", value: value, type: type, multi: multi, isCustomerCrew: !isCustomerCrew, boost: boost, partnerName: partnerName, isShowCashbackterm: isShowCashbackterm })),
            !isCookieEnabled && (React.createElement("div", { className: classes.cookieCardContainer }, !isCookieEnabled && React.createElement(CookieCard, { isShowCashbackterm: isShowCashbackterm }))),
            React.createElement(Divider, { className: classes.divider, variant: "fullWidth" }),
            React.createElement("div", { className: classes.textContainer },
                React.createElement("span", null, "D\u00E9tail"),
                React.createElement("div", { dangerouslySetInnerHTML: { __html: promotionData.description } })),
            React.createElement(Divider, { className: classes.divider, variant: "fullWidth" }),
            React.createElement("div", { className: classes.textContainer },
                React.createElement("span", null, "Validit\u00E9"),
                React.createElement("div", { className: classes.expiration }, toDateString(promotionData.start, promotionData.end))))));
};

/* eslint-disable @typescript-eslint/no-explicit-any */
var DidomiContainer = didomiModule.containers.DidomiContainer;
var CrewPartnerModal = function (_a) {
    var _b = _a.v2, v2 = _b === void 0 ? false : _b, _c = _a.isAuthenticated, isAuthenticated = _c === void 0 ? false : _c, partnerData = _a.partnerData, promotionData = _a.promotionData, firstButton = _a.firstButton, secondButton = _a.secondButton, onCloseCallBack = _a.onCloseCallBack, userData = _a.userData, activationAnswers = _a.activationAnswers, activationQuestions = _a.activationQuestions, _d = _a.isHidden, isHidden = _d === void 0 ? false : _d, isShowCashbackterm = _a.isShowCashbackterm;
    var bodyRef = useRef(null);
    var titleRef = useRef(null);
    var _e = useState(0), scrollTop = _e[0], setScrollTop = _e[1];
    var _f = useState(false), show = _f[0], setShow = _f[1];
    var _g = useState(false), showV2 = _g[0], setShowV2 = _g[1];
    var _h = useState(false), isCookieEnabled = _h[0], setIsCookieEnabled = _h[1];
    var updateCookies = function () {
        var _a, _b;
        var consents = (_a = window.Didomi) === null || _a === void 0 ? void 0 : _a.getUserStatus();
        var purposes = consents === null || consents === void 0 ? void 0 : consents.purposes;
        setIsCookieEnabled((_b = purposes === null || purposes === void 0 ? void 0 : purposes.consent) === null || _b === void 0 ? void 0 : _b.enabled.some(function (e) { return e === 'cookies'; }));
    };
    useEffect(function () {
        if (window.Didomi) {
            updateCookies();
        }
    }, []);
    var handleScroll = function (event) {
        setScrollTop(function () { return event.srcElement.scrollTop; });
    };
    useEffect(function () {
        var _a, _b, _c, _d, _e;
        var dataLayerCrewUserExist = ((_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.find(function (element) { return element.isCrewUser; })) !== undefined;
        var updateDataLayerCrewUser = !dataLayerCrewUserExist || (dataLayerCrewUserExist && !((_b = window.dataLayer) === null || _b === void 0 ? void 0 : _b.find(function (element) { return element.isCrewUser; }).isCrewUser));
        if (updateDataLayerCrewUser) {
            if (!dataLayerCrewUserExist || ((_c = userData === null || userData === void 0 ? void 0 : userData.crew) === null || _c === void 0 ? void 0 : _c.isCustomerCrew)) {
                (_d = window.dataLayer) === null || _d === void 0 ? void 0 : _d.push({ isCrewUser: (_e = userData === null || userData === void 0 ? void 0 : userData.crew) === null || _e === void 0 ? void 0 : _e.isCustomerCrew });
            }
        }
    }, []);
    useEffect(function () {
        if (scrollTop > 84) {
            setShow(true);
        }
        else {
            setShow(false);
        }
        if (scrollTop >= titleRef.current.offsetTop - 30) {
            setShowV2(true);
        }
        else {
            setShowV2(false);
        }
    }, [scrollTop]);
    useEffect(function () {
        var _a, _b;
        bodyRef.current.addEventListener('scroll', handleScroll);
        var eventPage = promotionData ? 'code_promo' : 'crew_popin_marque';
        var eventProps = {
            category_crew_main: partnerData.category,
            category_crew_sub: promotionData ? undefined : partnerData.category,
            partner_name: partnerData.title,
            user_id: (_a = userData === null || userData === void 0 ? void 0 : userData.profile) === null || _a === void 0 ? void 0 : _a.userId,
            super_points: (_b = userData === null || userData === void 0 ? void 0 : userData.priceClub) === null || _b === void 0 ? void 0 : _b.rank,
            voucher_type: promotionData ? promotionData.type : undefined,
        };
        var chapter1 = promotionData ? 'affiliate' : 'crew';
        var chapter3 = promotionData ? 'popin_voucher' : undefined;
        if (window.ATInternet) {
            setTimeout(function () {
                sendATInternetEvent(eventPage, eventProps, chapter1, chapter3);
            }, 0);
        }
        else {
            window.addEventListener('load', function () {
                sendATInternetEvent(eventPage, eventProps, chapter1, chapter3);
            });
        }
    }, []);
    var consentHasChanged = function () {
        updateCookies();
    };
    var imageUrl = partnerData.brand_illustration_url ? partnerData.brand_illustration_url : partnerData.logo_url;
    var color = partnerData.brand_illustration_bg ? partnerData.brand_illustration_bg : undefined;
    var body = (React.createElement(React.Fragment, null,
        !v2 && React.createElement(BrandScrollLogo, { show: show, title: partnerData.title }),
        React.createElement(BrandLogo, { imageUrl: imageUrl, color: color }),
        promotionData ? (React.createElement(CrewPromotionContentModal, { partnerData: partnerData, promotionData: promotionData, userData: userData, titleRef: titleRef, isCookieEnabled: isCookieEnabled, isShowCashbackterm: isShowCashbackterm })) : (React.createElement(CrewPartnerContentModal, { partnerData: partnerData, isAuthenticated: isAuthenticated, v2: v2, userData: userData, activationQuestions: activationQuestions, activationAnswers: activationAnswers, isHidden: isHidden, titleRef: titleRef, showV2: showV2, isCookieEnabled: isCookieEnabled, isShowCashbackterm: isShowCashbackterm })),
        React.createElement(DidomiContainer, { onConsentChanged: consentHasChanged })));
    var footer = React.createElement(CrewPartnerModalFooter, { firstButton: firstButton, secondButton: secondButton });
    return React.createElement(FullScreenModal, { bodyRef: bodyRef, modalOnCloseCallBack: onCloseCallBack, body: body, footer: footer });
};

var s$1 = {"bodyStyle":"_f-bodyStyle-89a75f","adBlockerModalContainer":"_f-adBlockerModalContainer-cf02a4","adBlockerModalTitle":"_f-adBlockerModalTitle-c25c06","adBlockerModalSubTitle":"_f-adBlockerModalSubTitle-401620","adBlockerModalButton":"_f-adBlockerModalButton-1ae137","adBlockerModalPopinSvg":"_f-adBlockerModalPopinSvg-aeb88e"};

/* eslint-disable max-len */
/* eslint-disable react/self-closing-comp */
var AdBlockerIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? '114' : _b, _c = _a.height, height = _c === void 0 ? '114' : _c, _d = _a.fill, fill = _d === void 0 ? colorPalette.gray900 : _d;
    return (React.createElement(SvgImg, { viewbox: "0 0 114 114", title: "app", width: width, height: height, fill: fill },
        React.createElement("circle", { cx: "57", cy: "57", r: "57", fill: "#FFF0F0" }),
        React.createElement("path", { d: "M24.3138 42H85V60.5294L70 62.0735L68.5 77H27.5L24 73L24.3138 42Z", fill: "white" }),
        React.createElement("path", { d: "M25 33H70C71.6569 33 73 34.3431 73 36V41H25V33Z", fill: "#FFD3D3" }),
        React.createElement("path", { d: "M84 57C84 57.5523 84.4477 58 85 58C85.5523 58 86 57.5523 86 57H84ZM64 78C64.5523 78 65 77.5523 65 77C65 76.4477 64.5523 76 64 76V78ZM28.6722 33H80.3278V31H28.6722V33ZM25 72.3278V36.6722H23V72.3278H25ZM84 36.6685V57H86V36.6685H84ZM64 76H28.6722V78H64V76ZM23 72.3278C23 75.4604 25.5395 78 28.6722 78V76C26.6441 76 25 74.3559 25 72.3278H23ZM80.3278 33C82.3569 33 84 34.6414 84 36.6685H86C86 33.5347 83.4594 31 80.3278 31V33ZM28.6722 31C25.5395 31 23 33.5395 23 36.6722H25C25 34.6441 26.6441 33 28.6722 33V31Z", fill: "#BF0000" }),
        React.createElement("circle", { cx: "79.5865", cy: "72.4016", r: "13.2002", fill: "#BF0000" }),
        React.createElement("path", { d: "M71.9996 72.4998H87.9996", stroke: "white", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M24.3359 41.5H85", stroke: "#BF0000", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M73.3947 32.3362V41.0002", stroke: "#BF0000", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("circle", { cx: "30.5", cy: "36.7", r: "1.5", fill: "#BF0000" }),
        React.createElement("circle", { cx: "36.5", cy: "36.7", r: "1.5", fill: "#BF0000" }),
        React.createElement("circle", { cx: "42.5", cy: "36.7", r: "1.5", fill: "#BF0000" })));
};

var AdBlockerModal = function (_a) {
    var handleClick = _a.handleClick, userData = _a.userData, onCloseCallBack = _a.onCloseCallBack;
    useEffect(function () {
        var _a, _b;
        var eventPage = 'popin_adblocker';
        var eventProps = {
            user_id: (_a = userData === null || userData === void 0 ? void 0 : userData.profile) === null || _a === void 0 ? void 0 : _a.userId,
            super_points: (_b = userData === null || userData === void 0 ? void 0 : userData.priceClub) === null || _b === void 0 ? void 0 : _b.rank,
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (window.ATInternet) {
            setTimeout(function () {
                sendATInternetEvent(eventPage, eventProps);
            }, 0);
        }
        else {
            window.addEventListener('load', function () {
                sendATInternetEvent(eventPage, eventProps);
            });
        }
    }, []);
    var body = (React.createElement("div", { className: s$1.adBlockerModalContainer },
        React.createElement(AdBlockerIcon, null),
        React.createElement("h1", { className: s$1.adBlockerModalTitle }, "D\u00E9sactivez votre adblocker"),
        React.createElement("p", { className: s$1.adBlockerModalSubTitle }, "Pensez \u00E0 d\u00E9sactiver votre adblocker et \u00E0 accepter les cookies en arrivant sur le site du partenaire pour profiter de l\u2019offre de remboursement.")));
    var footer = (React.createElement("button", { type: "button", className: s$1.adBlockerModalButton, onClick: handleClick }, "J\u2019ai d\u00E9sactiv\u00E9 mon adblocker"));
    return React.createElement(FullScreenModal, { body: body, modalOnCloseCallBack: onCloseCallBack, footer: footer });
};

var s = {"crewPartnerSuccessModalContainer":"_f-crewPartnerSuccessModalContainer-34e690","crewPartnerSuccessMargin":"_f-crewPartnerSuccessMargin-aeba74","crewPartnerSuccessNoMargin":"_f-crewPartnerSuccessNoMargin-1a1dff","crewPartnerSuccessModalSvg":"_f-crewPartnerSuccessModalSvg-1a8295","crewPartnerSuccessModalTitle":"_f-crewPartnerSuccessModalTitle-66859b","externalLinkicon":"_f-externalLinkicon-c53844","crewPartnerSuccessModalButton":"_f-crewPartnerSuccessModalButton-347b60","crewPartnerSuccessModalButtonHidden":"_f-crewPartnerSuccessModalButtonHidden-a28a77","accordionContainer":"_f-accordionContainer-81b396","accordion":"_f-accordion-58a80e","accordionItemContainer":"_f-accordionItemContainer-78c64c","externalLinkContainer":"_f-externalLinkContainer-8e5cff","externalLinkText":"_f-externalLinkText-fa0db4","chevron":"_f-chevron-5444fc","cardContainer":"_f-cardContainer-4f036f"};

var ExternalLinkIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? '16' : _b, _c = _a.height, height = _c === void 0 ? '17' : _c, _d = _a.fill, fill = _d === void 0 ? colorPalette.gray900 : _d;
    return (React.createElement(SvgImg, { viewbox: "0 0 16 17", title: "app", width: width, height: height, fill: fill },
        React.createElement("path", { d: "M10.5 13.7192H2.5V5.71924H6.5V4.71924H2.5C2.23478 4.71924 1.98043 4.8246 1.79289 5.01213C1.60536 5.19967 1.5 5.45402 1.5 5.71924V13.7192C1.5 13.9845 1.60536 14.2388 1.79289 14.4263C1.98043 14.6139 2.23478 14.7192 2.5 14.7192H10.5C10.7652 14.7192 11.0196 14.6139 11.2071 14.4263C11.3946 14.2388 11.5 13.9845 11.5 13.7192V9.71924H10.5V13.7192Z", fill: "white" }),
        React.createElement("path", { d: "M13.5 1.71924H8.5V2.71924H12.793L6.5 9.01224L7.2075 9.71924L13.5 3.42624V7.71924H14.5V2.71924V1.71924H13.5Z", fill: "white" })));
};

var CrewPartnerSuccessButton = function (_a) {
    var partnerTitle = _a.partnerTitle, crewUrl = _a.crewUrl, currentCount = _a.currentCount, buttonCallBefore = _a.buttonCallBefore;
    var buttonAction = function () {
        if (buttonCallBefore) {
            buttonCallBefore();
        }
        window.location.href = crewUrl;
    };
    return (React.createElement("button", { type: "button", className: s.crewPartnerSuccessModalButton, onClick: buttonAction },
        "Acheter sur ",
        partnerTitle,
        React.createElement("div", { className: s.externalLinkicon },
            React.createElement(ExternalLinkIcon, null)),
        React.createElement("span", null,
            " (",
            currentCount,
            " secondes)")));
};

var Card = function (_a) {
    var validationDelay = _a.validationDelay, cardTitle = _a.cardTitle, cardDescription = _a.cardDescription, imageUrl = _a.imageUrl;
    var displayLink = function () { return (React.createElement("div", { className: s$2.externalLinkContainer },
        React.createElement(Link, { label: "Voir ma cagnotte", url: "https://fr.shopping.rakuten.com/user/club", rightIcon: React.createElement(ArrowForwardOutlined, null), openUrlInNewTab: false, marginBottom: "0px", underline: true }))); };
    return (React.createElement("div", { className: s$2.cardContainer },
        React.createElement("div", { className: s$2.logoContainer },
            React.createElement("div", { className: s$2.logo },
                React.createElement("img", { src: imageUrl, alt: "logo" }))),
        React.createElement("div", { className: s$2.textContainer },
            React.createElement("p", { className: s$2.title }, cardTitle),
            React.createElement("p", { className: s$2.duration }, validationDelay),
            React.createElement("p", { className: s$2.description }, cardDescription),
            displayLink())));
};

var CrewPartnerSuccessModal = function (_a) {
    var _b = _a.disableRedirection, disableRedirection = _b === void 0 ? false : _b, cardDescription = _a.cardDescription, cardTitle = _a.cardTitle, partnerData = _a.partnerData, userData = _a.userData, _c = _a.darkBgModal, darkBgModal = _c === void 0 ? false : _c, onCloseCallBack = _a.onCloseCallBack, modalTitle = _a.modalTitle, redirectAllowed = _a.redirectAllowed, _d = _a.isFinalStep, isFinalStep = _d === void 0 ? false : _d, _e = _a.isCloseIcon, isCloseIcon = _e === void 0 ? false : _e, _f = _a.infoUrl, infoUrl = _f === void 0 ? '#' : _f, postQuestions = _a.postQuestions, postAnswers = _a.postAnswers, validationDelay = _a.validationDelay, partnerUrl = _a.partnerUrl;
    var routeChange = function (url) {
        window.open(url);
    };
    var _g = useState(0), intervalId = _g[0], setIntervalId = _g[1];
    var _h = useState(5), currentCount = _h[0], setCount = _h[1];
    var timer = function () { return setCount(function (prevCount) { return prevCount - 1; }); };
    var sendRedirectEvent = function () {
        var _a, _b;
        var eventPage = 'remboursement_active_bis';
        var eventProps = {
            user_id: (_a = userData === null || userData === void 0 ? void 0 : userData.profile) === null || _a === void 0 ? void 0 : _a.userId,
            super_points: (_b = userData === null || userData === void 0 ? void 0 : userData.priceClub) === null || _b === void 0 ? void 0 : _b.rank,
        };
        if (window.ATInternet) {
            setTimeout(function () {
                sendATInternetEvent(eventPage, eventProps);
            }, 0);
        }
        else {
            window.addEventListener('load', function () {
                sendATInternetEvent(eventPage, eventProps);
            });
        }
    };
    useEffect(function () {
        sendRedirectEvent();
    }, []);
    var buttonCallBefore = function () {
        clearInterval(intervalId);
        sendRedirectEvent();
    };
    useEffect(function () {
        if (currentCount <= 0 && redirectAllowed) {
            sendRedirectEvent();
            clearInterval(intervalId);
            window.location.href = partnerUrl;
        }
    }, [currentCount, redirectAllowed]);
    useEffect(
    // eslint-disable-next-line consistent-return
    function () {
        var _a, _b;
        if (!disableRedirection) {
            var eventPage_1 = 'remboursement_active';
            var eventProps_1 = {
                category_crew_main: partnerData.category,
                category_crew_sub: partnerData.category,
                patner_name: partnerData.title,
                user_id: (_a = userData === null || userData === void 0 ? void 0 : userData.profile) === null || _a === void 0 ? void 0 : _a.userId,
                super_points: (_b = userData === null || userData === void 0 ? void 0 : userData.priceClub) === null || _b === void 0 ? void 0 : _b.rank,
            };
            if (window.ATInternet) {
                setTimeout(function () {
                    sendATInternetEvent(eventPage_1, eventProps_1);
                }, 0);
            }
            else {
                window.addEventListener('load', function () {
                    sendATInternetEvent(eventPage_1, eventProps_1);
                });
            }
            var id_1 = setInterval(timer, 1000);
            setIntervalId(id_1);
            return function () { return clearInterval(id_1); };
        }
    }, []);
    var displayLink = function () { return (React.createElement("div", { className: s.externalLinkContainer },
        React.createElement(Link, { label: "Plus d'informations", url: infoUrl, rightIcon: React.createElement(ArrowForwardOutlined, null), openUrlInNewTab: false, underline: true }))); };
    var body = (React.createElement("div", { className: "".concat(s.crewPartnerSuccessModalContainer, " ").concat(s.crewPartnerSuccessMargin) },
        React.createElement("div", { className: s.crewPartnerSuccessModalSvg },
            React.createElement("img", { src: "https://fr.shopping.rakuten.com/visuels/0_next-common/crew-partner-modal/cart_1.png", alt: "cart" })),
        React.createElement("h1", { className: s.crewPartnerSuccessModalTitle }, modalTitle),
        React.createElement("div", { className: s.cardContainer },
            React.createElement(Card, { validationDelay: validationDelay, cardDescription: cardDescription, cardTitle: cardTitle, imageUrl: partnerData.logo_url })),
        React.createElement("div", { className: s.accordionContainer },
            (postAnswers === null || postAnswers === void 0 ? void 0 : postAnswers.firstAnswer) && (React.createElement("div", { className: s.accordion },
                React.createElement(AccordionItem, { title: postQuestions[0], description: postAnswers.firstAnswer }))),
            (postAnswers === null || postAnswers === void 0 ? void 0 : postAnswers.secondAnswer) && (React.createElement("div", { className: s.accordionItemContainer },
                React.createElement(AccordionItem, { title: postQuestions[1], description: postAnswers.secondAnswer }, displayLink()))),
            (partnerData === null || partnerData === void 0 ? void 0 : partnerData.conditions) && (React.createElement("div", { className: s.accordionItemContainer },
                React.createElement(AccordionItem, { title: "Conditions particuli\u00E8res", description: partnerData.conditions, isList: true }))))));
    var footer = isFinalStep ? (React.createElement(CrewPartnerModalFooter, { firstButton: {
            buttonLabel: "Acheter sur ".concat(partnerData.title),
            buttonAction: function () { return routeChange(partnerUrl); },
            // @ts-expect-error ts-migrate(2322) FIXME: Type '{ className: any; }' is not assignable to ty... Remove this comment to see the full error message
            icon: React.createElement(ExternalLinkIcon, { className: s.externalLinkicon }),
        } })) : (React.createElement(CrewPartnerSuccessButton, { partnerTitle: partnerData.title, currentCount: currentCount, crewUrl: partnerUrl, buttonCallBefore: buttonCallBefore }));
    return (React.createElement(FullScreenModal, { withCloseIcon: isCloseIcon, modalOnCloseCallBack: onCloseCallBack, body: body, footer: footer, darkBgModal: darkBgModal }));
};

/* eslint-disable @typescript-eslint/ban-ts-comment */
var getComponentByStep = function (step) {
    switch (step) {
        case STEPS.PARTNER_MODAL:
            // @ts-ignore
            return CrewPartnerModal;
        case STEPS.EXTENSION_MODAL:
            // @ts-ignore
            return AdBlockerModal;
        case STEPS.PARTNER_SUCCESS_MODAL:
            // @ts-ignore
            return CrewPartnerSuccessModal;
        case STEPS.PARTNER_SUCCESS_MODAL_FINAL:
            // @ts-ignore
            return CrewPartnerSuccessModal;
        default:
            return null;
    }
};
var StepsContainer = function (_a) {
    var isAuthenticated = _a.isAuthenticated, isSubscribed = _a.isSubscribed, partnerData = _a.partnerData, promotionData = _a.promotionData, step = _a.step, handleRedirectPartner = _a.handleRedirectPartner, handleAdBlockClick = _a.handleAdBlockClick, onCloseCallBack = _a.onCloseCallBack, userData = _a.userData, activationQuestions = _a.activationQuestions, activationAnswers = _a.activationAnswers, postQuestions = _a.postQuestions, postAnswers = _a.postAnswers, validationDelay = _a.validationDelay, redirectUrl = _a.redirectUrl, redirectAllowed = _a.redirectAllowed, advertId = _a.advertId, productId = _a.productId, isShowCashbackterm = _a.isShowCashbackterm;
    var partnerName = useSelector(function (state) { return state.crewPartnerModal && state.crewPartnerModal.partnerName; });
    var StepComponent = getComponentByStep(parseInt(step, 10));
    var CrewPartnerUnSubModalComponent = (
    // @ts-expect-error ts-migrate(2322) FIXME: Type '{ onCloseCallBack: Function; isAuthenticated... Remove this comment to see the full error message
    React.createElement(StepComponent, { onCloseCallBack: onCloseCallBack, isAuthenticated: isAuthenticated, partnerData: partnerData, promotionData: promotionData, activationQuestions: activationQuestions, activationAnswers: activationAnswers, isShowCashbackterm: isShowCashbackterm, firstButton: {
            buttonLabel: registerButtonLabel,
            buttonAction: function () { handleRegister(partnerName, productId, advertId); },
        }, userData: userData }));
    var CrewPartnerSubModalComponent = (
    // @ts-expect-error ts-migrate(2322) FIXME: Type '{ onCloseCallBack: Function; isAuthenticated... Remove this comment to see the full error message
    React.createElement(StepComponent, { onCloseCallBack: onCloseCallBack, isAuthenticated: isAuthenticated, partnerData: partnerData, promotionData: promotionData, activationQuestions: activationQuestions, activationAnswers: activationAnswers, isShowCashbackterm: isShowCashbackterm, firstButton: {
            buttonLabel: partnerModalActionLabel,
            buttonAction: handleRedirectPartner,
        }, userData: userData }));
    // @ts-expect-error ts-migrate(2322) FIXME: Type '{ userData: any[]; onCloseCallBack: Function... Remove this comment to see the full error message
    var AdBlockModalComponent = React.createElement(StepComponent, { userData: userData, onCloseCallBack: onCloseCallBack, handleClick: handleAdBlockClick });
    var CrewPartnerSuccessModalComponent = (
    // @ts-ignore
    React.createElement(StepComponent, { cardTitle: isShowCashbackterm ? offerTitleBookingLabel : offerTitleLabel, modalTitle: React.createElement(React.Fragment, null, "Vous avez fait votre achat ?"), cardDescription: isShowCashbackterm ? offerDescBookingLabel : offerDescLabel, partnerUrl: redirectUrl, onCloseCallBack: onCloseCallBack, userData: userData, partnerData: partnerData, promotionData: promotionData, redirectAllowed: redirectAllowed, darkBgModal: true, postQuestions: postQuestions, postAnswers: postAnswers, validationDelay: validationDelay, infoUrl: infoUrl, isShowCashbackterm: isShowCashbackterm }));
    var CrewPartnerSuccessFinalModalComponent = (
    // @ts-ignore
    React.createElement(StepComponent, { disableRedirection: true, cardTitle: isShowCashbackterm ? offerTitleBookingLabel : offerTitleLabel, modalTitle: React.createElement(React.Fragment, null, "Vous avez fait votre achat ?"), cardDescription: isShowCashbackterm ? offerDescBookingLabel : offerDescLabel, partnerUrl: redirectUrl, onCloseCallBack: onCloseCallBack, userData: userData, partnerData: partnerData, promotionData: promotionData, isFinalStep: true, postQuestions: postQuestions, postAnswers: postAnswers, validationDelay: validationDelay, infoUrl: infoUrl, isShowCashbackterm: isShowCashbackterm, isCloseIcon: true }));
    // @ts-expect-error ts-migrate(2367) FIXME: This condition will always return 'false' since th... Remove this comment to see the full error message
    if (step === STEPS.PARTNER_MODAL) {
        return StepComponent && isSubscribed ? CrewPartnerSubModalComponent : CrewPartnerUnSubModalComponent;
    }
    // @ts-expect-error ts-migrate(2367) FIXME: This condition will always return 'false' since th... Remove this comment to see the full error message
    if (step === STEPS.EXTENSION_MODAL) {
        return StepComponent && AdBlockModalComponent;
    }
    // @ts-expect-error ts-migrate(2367) FIXME: This condition will always return 'false' since th... Remove this comment to see the full error message
    if (step === STEPS.PARTNER_SUCCESS_MODAL) {
        return StepComponent && CrewPartnerSuccessModalComponent;
    }
    // @ts-expect-error ts-migrate(2367) FIXME: This condition will always return 'false' since th... Remove this comment to see the full error message
    if (step === STEPS.PARTNER_SUCCESS_MODAL_FINAL) {
        return StepComponent && CrewPartnerSuccessFinalModalComponent;
    }
    // @ts-expect-error ts-migrate(2322) FIXME: Type '{}' is not assignable to type 'IntrinsicAttr... Remove this comment to see the full error message
    return StepComponent && React.createElement(StepComponent, null);
};

var getUserID = function (userData) { return userData && userData.profile && userData.profile.userId; };
var isUserLogged = function (userData) {
    var userId = getUserID(userData);
    return userId && userId !== 0 && Number.isInteger(userId);
};
var isUserSubscribed = function (userData) { return userData && userData.priceClub && userData.priceClub.isSubscribed; };

var getConsentCookie = function (platformId, userId) {
    var gdprConsent = ''; // KWANKO
    var cnst = 'g2p'; // Rak Adv Permet d'indiquer a RakAdv les types de consentements acceptes (purposes)
    var cjgdpr = '0'; // CJ
    var cjgdprType = '7';
    var consents = window.Didomi.getUserConsentStatusForAll();
    var purposes = consents.purposes;
    var consentPurposes = {
        cookies: '1',
        select_basic_ads: '2',
        create_ads_profile: '3',
        select_personalized_ads: '4',
        create_content_profile: '5',
        select_personalized_content: '6',
        measure_ad_performance: '7',
        measure_content_performance: '8',
        market_research: '9',
        improve_products: '10',
    };
    purposes.enabled.forEach(function (purpose) {
        var enabledPurpose = consentPurposes[purpose];
        if (enabledPurpose) {
            cnst = "".concat(cnst + enabledPurpose, ",");
            if (enabledPurpose === '1') {
                cjgdpr = '1';
            }
        }
    });
    purposes.disabled.forEach(function (purpose) {
        var declinedPurpose = consentPurposes[purpose];
        if (declinedPurpose) {
            if (declinedPurpose === '1') {
                cjgdpr = '0';
            }
        }
    });
    var n = cnst.lastIndexOf(',');
    if (n !== -1) {
        cnst = cnst.substr(0, n); // On retire la dernière virgule
    }
    var getTCData = function (tcData, success) {
        if (success && tcData.eventStatus === 'tcloaded') {
            gdprConsent = tcData.tcString;
        }
    };
    // @ts-expect-error didomi class.
    __tcfapi('addEventListener', 2, getTCData);
    switch (platformId) {
        case 10: // CJ
            return "&cjgdpr=".concat(cjgdpr, "&cjgdprType=").concat(cjgdprType);
        case 4: // KWANKO
        case 14: // KWANKO
            return "&gdpr_consent=".concat(gdprConsent, "&gdpr_cb=").concat(userId);
        case 6: // RakAd
            return "&cnst=".concat(cnst);
        case 1: //effiliation
            return "&gdpr=1&&gdpr_consent=".concat(gdprConsent);
        default:
            return '';
    }
};

var CrewPartnerLoggedInModal = function (_a) {
    var _b;
    var isAuthenticated = _a.isAuthenticated, partnerData = _a.partnerData, promotionData = _a.promotionData, activationQuestions = _a.activationQuestions, activationAnswers = _a.activationAnswers, postQuestions = _a.postQuestions, postAnswers = _a.postAnswers, validationDelay = _a.validationDelay, partnerUrl = _a.partnerUrl, advertId = _a.advertId, productId = _a.productId, isShowCashbackterm = _a.isShowCashbackterm, onCloseCallBack = _a.onCloseCallBack;
    var dispatch = useDispatch();
    var step = useSelector(function (state) { return state.crewPartnerModal && state.crewPartnerModal.step; });
    var isAdblockActive = useSelector(function (state) { return state.crewPartnerModal && state.crewPartnerModal.isAdblockActive; });
    var partnerName = useSelector(function (state) { return state.crewPartnerModal && state.crewPartnerModal.partnerName; });
    var userData = useSelector(function (state) { return state.crewPartnerModal && state.crewPartnerModal.userData; });
    var loadedData = useSelector(function (state) { return state.crewPartnerModal && state.crewPartnerModal.loadedData; });
    var md = useSelector(function (state) { return state.md; });
    var _c = useState(''), consentCookie = _c[0], setConsentCookie = _c[1];
    var _d = useState(''), redirectUrl = _d[0], setRedirectUrl = _d[1];
    var _e = useState(false), redirectAllowed = _e[0], setRedirectAllowed = _e[1];
    var clubSubscriber = isUserSubscribed(userData);
    var isEventPage = window.location.href.includes('/event/');
    var isSearchPage = window.location.href.includes('/search/');
    var isSeoSearchPage = window.location.href.includes('/s/');
    var isAffiliatePage = window.location.href.includes('/affiliate/');
    var isHomePage = window.location.pathname === '/';
    var wsRedirectionLink = "".concat(partnerUrl).concat(consentCookie);
    var redirection = (isEventPage ||
        isSearchPage ||
        isHomePage ||
        isSeoSearchPage ||
        isAffiliatePage) ? redirectUrl : wsRedirectionLink || redirectUrl;
    var handleConsentCookie = function () {
        var _a;
        if (window.Didomi && partnerData.platform && userData.profile && md) {
            var cookie = getConsentCookie(partnerData.platform.id, (_a = userData === null || userData === void 0 ? void 0 : userData.profile) === null || _a === void 0 ? void 0 : _a.userId);
            setConsentCookie(cookie);
            setRedirectAllowed(true);
        }
    };
    useEffect(function () {
        if (window.Didomi) {
            setTimeout(function () {
                handleConsentCookie();
            }, 0);
        }
        else {
            window.addEventListener('load', function () {
                handleConsentCookie();
            });
        }
    }, []);
    useEffect(function () {
        var _a;
        if (md) {
            setRedirectUrl(getRedirectUrl(loadedData, partnerData, userData === null || userData === void 0 ? void 0 : userData.partnerUrl, (_a = userData === null || userData === void 0 ? void 0 : userData.profile) === null || _a === void 0 ? void 0 : _a.userId, consentCookie, md));
        }
    }, [loadedData, partnerData, (_b = userData === null || userData === void 0 ? void 0 : userData.profile) === null || _b === void 0 ? void 0 : _b.userId, consentCookie, md]);
    var handleRedirectPartner = function () {
        var _a, _b;
        if (isAdblockActive) {
            dispatch({ type: actionTypes.SHOW_EXTENSION_MODAL });
        }
        else {
            var eventPage_1 = 'remboursement_active';
            var eventProps_1 = {
                category_crew_main: partnerData.category,
                category_crew_sub: partnerData.category,
                partner_name: partnerData.title,
                user_id: (_a = userData === null || userData === void 0 ? void 0 : userData.profile) === null || _a === void 0 ? void 0 : _a.userId,
                super_points: (_b = userData === null || userData === void 0 ? void 0 : userData.priceClub) === null || _b === void 0 ? void 0 : _b.rank,
            };
            if (window.ATInternet) {
                setTimeout(function () {
                    sendATInternetEvent(eventPage_1, eventProps_1);
                }, 0);
            }
            else {
                window.addEventListener('load', function () {
                    sendATInternetEvent(eventPage_1, eventProps_1);
                });
            }
            dispatch(openRedirectModal(partnerName, loadedData, redirection));
        }
    };
    var handleAdBlockClick = function () {
        window.location.reload();
    };
    useEffect(function () {
        if (step === STEPS.PARTNER_SUCCESS_MODAL) {
            if (isAdblockActive) {
                dispatch({ type: actionTypes.SHOW_EXTENSION_MODAL });
            }
            else {
                dispatch({ type: actionTypes.SHOW_PARTNER_SUCCESS_MODAL });
            }
        }
        else if (step === STEPS.EXTENSION_MODAL) {
            handleRedirectPartner();
        }
    }, [isAdblockActive]);
    useEffect(function () {
        if (step === STEPS.PARTNER_SUCCESS_MODAL) {
            dispatch(checkAdBlock);
        }
    }, [step]);
    return (React.createElement(StepsContainer, { isAuthenticated: isAuthenticated, partnerData: partnerData, promotionData: promotionData, step: step, handleRedirectPartner: handleRedirectPartner, handleAdBlockClick: handleAdBlockClick, userData: userData, onCloseCallBack: onCloseCallBack, isSubscribed: clubSubscriber, activationQuestions: activationQuestions, activationAnswers: activationAnswers, postQuestions: postQuestions, postAnswers: postAnswers, validationDelay: validationDelay, redirectUrl: redirection, redirectAllowed: redirectAllowed, productId: productId, advertId: advertId, isShowCashbackterm: isShowCashbackterm }));
};

var CrewPartnerNotLoggedInModal = function (_a) {
    var isAuthenticated = _a.isAuthenticated, partnerName = _a.partnerName, partnerData = _a.partnerData, promotionData = _a.promotionData, activationQuestions = _a.activationQuestions, activationAnswers = _a.activationAnswers, advertId = _a.advertId, productId = _a.productId, isShowCashbackterm = _a.isShowCashbackterm, onCloseCallBack = _a.onCloseCallBack;
    return (React.createElement(CrewPartnerModal, { isAuthenticated: isAuthenticated, isShowCashbackterm: isShowCashbackterm, partnerData: partnerData, promotionData: promotionData, activationQuestions: activationQuestions, activationAnswers: activationAnswers, firstButton: {
            buttonLabel: connectButtonLabel,
            buttonAction: function () { handleLogin(partnerName, advertId, productId); },
        }, secondButton: {
            buttonLabel: registerButtonLabel,
            buttonAction: function () { handleRegister(partnerName, advertId, productId); },
        }, onCloseCallBack: onCloseCallBack }));
};

var INITIAL_QUERY = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["query crew {\n  profile {\n    firstNameOrPseudo\n    userId\n  }\n  priceClub {\n    isSubscribed\n    rank\n  }\n  crew {\n    isCustomerCrew\n  }\n}\n"], ["query crew {\n  profile {\n    firstNameOrPseudo\n    userId\n  }\n  priceClub {\n    isSubscribed\n    rank\n  }\n  crew {\n    isCustomerCrew\n  }\n}\n"])));
var CREW_QUERY = gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["query getCrewPartner ($crewPartnerInput: CrewPartnerInput!) {\n  crewPartner (crewPartnerInput: $crewPartnerInput) {\n    partnerUrl\n  }\n  profile {\n    firstNameOrPseudo\n    userId\n  }\n  priceClub {\n    isSubscribed\n    rank\n  }\n  crew {\n    isCustomerCrew\n  }\n}\n"], ["query getCrewPartner ($crewPartnerInput: CrewPartnerInput!) {\n  crewPartner (crewPartnerInput: $crewPartnerInput) {\n    partnerUrl\n  }\n  profile {\n    firstNameOrPseudo\n    userId\n  }\n  priceClub {\n    isSubscribed\n    rank\n  }\n  crew {\n    isCustomerCrew\n  }\n}\n"])));
var templateObject_1, templateObject_2;

var limitObjects = function (input, condition) {
    if (!condition) {
        var result = {};
        for (var key in input) {
            if (Object.prototype.hasOwnProperty.call(input, key)) {
                result[key] = input[key].slice(0, 1);
            }
        }
        return result;
    }
    else {
        return input;
    }
};

var Router;
try {
    Router = require('next/router');
}
catch (e) {
    Router = null;
}
var CrewPartnerModalContainer = function (advertCrewModale) {
    var _a, _b, _c, _d, _e, _f, _g;
    var showPopin = useSelector(function (state) { return state.crewPartnerModal && state.crewPartnerModal.showPopin; });
    var partnerName = useSelector(function (state) { return state.crewPartnerModal && state.crewPartnerModal.partnerName; });
    var promotionId = useSelector(function (state) { return state.crewPartnerModal && state.crewPartnerModal.promotionId; });
    var partnerData = useSelector(function (state) { return state.crewPartnerModal && state.crewPartnerModal.partnerData; });
    var promotionData = useSelector(function (state) { return state.crewPartnerModal && state.crewPartnerModal.promotionData; });
    var userData = useSelector(function (state) { return state.crewPartnerModal && state.crewPartnerModal.userData; });
    var loadedData = useSelector(function (state) { return state.crewPartnerModal && state.crewPartnerModal.loadedData; });
    var md = useSelector(function (state) { return state.md; });
    var _h = useState(null), advertId = _h[0], setAdvertId = _h[1];
    var _j = useState(null), productId = _j[0], setProduct = _j[1];
    var dispatch = useDispatch();
    var isConnected = isUserLogged(userData);
    var ref = useRef(false);
    var _k = useState(''), consentCookie = _k[0], setConsentCookie = _k[1];
    var query_options = {
        crewPartnerInput: {
            sellerLogin: "ClubR_".concat(partnerName),
            advertId: advertId,
            productId: productId,
            channelId: getChannelId(md),
            tracking: 23,
        },
    };
    var initialQuery = useQuery(INITIAL_QUERY);
    var isSkipQuery = !productId || !partnerName;
    var crewQuery = useQuery(CREW_QUERY, { variables: query_options, skip: isSkipQuery });
    function isNextApplication() {
        var _a;
        try {
            // eslint-disable-next-line react-hooks/rules-of-hooks
            var router = typeof window !== 'undefined' ? useRouter() : null;
            //pour savoir si on est sur fp ou page event
            return (_a = router === null || router === void 0 ? void 0 : router.asPath) === null || _a === void 0 ? void 0 : _a.includes('Clubr');
        }
        catch (e) {
            return false;
        }
    }
    var isVisNextUrl = isNextApplication();
    if (!isVisNextUrl && initialQuery && !initialQuery.loading) {
        dispatch({ type: actionTypes.FETCH_USER_DATA_SUCCESS, payload: initialQuery.data });
        ref.current = true;
    }
    useEffect(function () {
        if (advertId && !ref.current) {
            dispatch({ type: actionTypes.FETCH_USER_DATA_SUCCESS, payload: crewQuery.data });
        }
    }, [advertId]);
    // eslint-disable-next-line camelcase
    var isShowCashbackterm = (_a = partnerData === null || partnerData === void 0 ? void 0 : partnerData.cashback) === null || _a === void 0 ? void 0 : _a.hideCashbackTerm;
    var validationDelay = (partnerData === null || partnerData === void 0 ? void 0 : partnerData.validation_delay)
        ? partnerData === null || partnerData === void 0 ? void 0 : partnerData.validation_delay
        : "".concat(partnerData === null || partnerData === void 0 ? void 0 : partnerData.point_attribution_estimated, " jours") || '';
    var refundAnswer = {
        refundAnswer: [
            {
                id: 0,
                title: 'Délais d’apparition',
                sub: "".concat(isShowCashbackterm ? 'Les Rakuten Points peuvent' : 'Le cashback peut', " prendre quelques jours pour appara\u00EEtre sur votre compte Club R"),
            },
            {
                id: 1,
                title: 'Délais de validation',
                sub: "".concat(validationDelay, " d'attente environ avant validation ").concat(isShowCashbackterm ? 'des Rakuten Points' : 'du cashback'),
            },
        ],
        longRefundAnswer: [
            {
                id: 0,
                title: 'Délais d’apparition',
                sub: "".concat(isShowCashbackterm ? 'Les Rakuten Points apparaitront' : 'Le cashback apparaitra', " sur votre compte Club R d\u2019ici quelques jours."),
            },
            {
                id: 1,
                title: 'Délais de validation',
                sub: "".concat(isShowCashbackterm ? 'Les Rakuten Points arriveront' : 'Le cashback arrivera', " 12 semaines apr\u00E8s la consommation du voyage ou de l'activit\u00E9."),
            },
        ],
    };
    var limitedAnwers = limitObjects(refundAnswer, !!(partnerData === null || partnerData === void 0 ? void 0 : partnerData.point_attribution_estimated));
    var answers = __assign(__assign({}, crewAnswers), limitedAnwers);
    var bookingAnswers = __assign(__assign({}, crewBookingAnswers), refundAnswer);
    var handleLoadPartner = function (event) {
        dispatch(loadPartnerFromEvent(event.detail.partner, event.detail.promotionId));
        if (isVisNextUrl && event.detail.partner) {
            if (event.detail.promotionId) {
                dispatch(fetchCrewPartnerDataWithCodePromoData(event.detail.partner, event.detail.promotionId));
            }
            else {
                dispatch(fetchCrewPartnerData(event.detail.partner));
            }
        }
    };
    var postQuestions = [
        "Pourquoi ".concat(validationDelay, " avant la validation ?"),
        isShowCashbackterm ? 'Mes Rakuten Points peuvent-ils être non éligibles ?' : 'Mon cashback peut-il être non éligible ?',
    ];
    useEffect(function () {
        dispatch({ type: actionTypes.FETCH_USER_DATA_REQUEST });
        document.addEventListener('CREW-MODAL-PARTNER', handleLoadPartner);
        dispatch(loadPartnerFromLink);
        dispatch(checkAdBlock);
        dispatch(initCrewBtnListeners);
        return function () {
            document.removeEventListener('CREW-MODAL-PARTNER', handleLoadPartner);
        };
    }, []);
    useEffect(function () {
        if (showPopin && partnerName) {
            if (promotionId) {
                dispatch(fetchCrewPartnerDataWithCodePromoData(partnerName, promotionId));
            }
            else {
                dispatch(fetchCrewPartnerData(partnerName));
            }
        }
    }, [showPopin, partnerName]);
    useEffect(function () {
        dispatch(initFPCrewBtnListener((userData === null || userData === void 0 ? void 0 : userData.partnerUrl) || (partnerData === null || partnerData === void 0 ? void 0 : partnerData.link) || '', setProduct, setAdvertId));
    }, [partnerData]);
    var onCloseCallBack = function () {
        dispatch(handleOnClose(isVisNextUrl));
    };
    var handleConsentCookie = function () {
        var _a, _b;
        if (window.Didomi && partnerData.platform && md) {
            //if the user is not connected, we must have 0 for the userId
            var userId = (_b = (_a = userData === null || userData === void 0 ? void 0 : userData.profile) === null || _a === void 0 ? void 0 : _a.userId) !== null && _b !== void 0 ? _b : 0;
            var cookie = getConsentCookie(partnerData.platform.id, userId);
            setConsentCookie(cookie);
        }
    };
    useEffect(function () {
        if (partnerData && userData && window.Didomi) {
            setTimeout(function () {
                handleConsentCookie();
            }, 0);
        }
        else if (partnerData && userData) {
            window.addEventListener('load', function () {
                handleConsentCookie();
            });
        }
    }, [partnerData, userData]);
    if (shouldRedirectUnloggedUsersDirectly(md, advertCrewModale) &&
        initialQuery &&
        crewQuery &&
        !initialQuery.loading &&
        !crewQuery.loading &&
        !isConnected &&
        !isVisNextUrl &&
        loadedData &&
        partnerData &&
        userData) {
        var redirectUrl = void 0;
        if ((promotionData === null || promotionData === void 0 ? void 0 : promotionData.link) || ((_c = (_b = crewQuery === null || crewQuery === void 0 ? void 0 : crewQuery.data) === null || _b === void 0 ? void 0 : _b.crewPartner) === null || _c === void 0 ? void 0 : _c.partnerUrl)) {
            if (promotionData === null || promotionData === void 0 ? void 0 : promotionData.link) {
                redirectUrl = promotionData.link;
            }
            else {
                redirectUrl = (_e = (_d = crewQuery.data) === null || _d === void 0 ? void 0 : _d.crewPartner) === null || _e === void 0 ? void 0 : _e.partnerUrl;
            }
            if (consentCookie) {
                redirectUrl = "".concat(redirectUrl).concat(consentCookie);
            }
        }
        else {
            //fallback in case graphql doesn't work ;this shouldn't happen
            redirectUrl = getRedirectUrl(loadedData, partnerData, userData === null || userData === void 0 ? void 0 : userData.partnerUrl, 0, consentCookie, md);
        }
        window.open(redirectUrl, '_blank');
        return React.createElement(React.Fragment, null);
    }
    else {
        return (partnerData &&
            showPopin &&
            initialQuery &&
            crewQuery &&
            !initialQuery.loading &&
            !crewQuery.loading &&
            (isConnected ? (React.createElement(CrewPartnerLoggedInModal, { isAuthenticated: isConnected, partnerData: partnerData, promotionData: promotionData, onCloseCallBack: onCloseCallBack, activationQuestions: isShowCashbackterm ? crewBookingQuestions : crewQuestions, activationAnswers: isShowCashbackterm ? bookingAnswers : answers, postQuestions: postQuestions, postAnswers: isShowCashbackterm ? postBookingAnswers : postAnswers, validationDelay: validationDelay, partnerUrl: (_g = (_f = crewQuery.data) === null || _f === void 0 ? void 0 : _f.crewPartner) === null || _g === void 0 ? void 0 : _g.partnerUrl, productId: productId, advertId: advertId, isShowCashbackterm: isShowCashbackterm })) : (React.createElement(CrewPartnerNotLoggedInModal, { isAuthenticated: isConnected, partnerData: partnerData, promotionData: promotionData, partnerName: partnerName, onCloseCallBack: onCloseCallBack, activationQuestions: isShowCashbackterm ? crewBookingQuestions : crewQuestions, activationAnswers: isShowCashbackterm ? bookingAnswers : answers, productId: productId, advertId: advertId, isShowCashbackterm: isShowCashbackterm }))));
    }
};
var shouldRedirectUnloggedUsersDirectly = function (md, advertCrewModale) {
    var isBuyerApp = md.isEmbeddedInBuyerApp;
    return !isBuyerApp && advertCrewModale.instantRedirectDesktopActive;
};

var containers = /*#__PURE__*/Object.freeze({
  __proto__: null,
  CrewPartnerModalContainer: CrewPartnerModalContainer
});

var initialState = {
    showPopin: false,
    isReady: false,
    loading: false,
    partnerName: null,
    promotionId: null,
    partnerData: null,
    error: null,
    step: null,
    isAdblockActive: false,
    userData: null,
    loadedData: null,
    promotionData: null
};
function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case actionTypes.SHOW_CREW_PARTNER_MODAL:
            return __assign(__assign({}, state), { showPopin: true, partnerName: formatPartnerName(action.payload.partner), promotionId: action.payload.promotionId, step: action.payload.step, loadedData: action.payload.loadedData });
        case actionTypes.INIT_CREW_PARTNER_MODAL:
            return __assign(__assign({}, state), { isReady: true });
        case actionTypes.FETCH_CREW_PARTNER_DATA_REQUEST:
            return __assign(__assign({}, state), { loading: true, error: false, partnerData: null });
        case actionTypes.FETCH_CREW_PARTNER_DATA_SUCCESS:
            return __assign(__assign({}, state), { loading: false, error: false, partnerData: action.payload });
        case actionTypes.FETCH_CREW_PARTNER_DATA_FAILURE:
            return __assign(__assign({}, state), { loading: false, error: true, partnerData: null });
        case actionTypes.FETCH_CREW_PARTNER_AND_CODE_PROMO_DATA_REQUEST:
            return __assign(__assign({}, state), { loading: true, error: false, partnerData: null, promotionData: null });
        case actionTypes.FETCH_CREW_PARTNER_AND_CODE_PROMO_DATA_SUCCESS:
            return __assign(__assign({}, state), { loading: false, error: false, partnerData: action.payload.partnerData, promotionData: action.payload.promotionData });
        case actionTypes.FETCH_CREW_PARTNER_AND_CODE_PROMO_DATA_FAILURE:
            return __assign(__assign({}, state), { loading: false, error: true, partnerData: null, promotionData: null });
        case actionTypes.SHOW_EXTENSION_MODAL:
            return __assign(__assign({}, state), { step: STEPS.EXTENSION_MODAL });
        case actionTypes.SHOW_PARTNER_SUCCESS_MODAL:
            return __assign(__assign({}, state), { step: STEPS.PARTNER_SUCCESS_MODAL });
        case actionTypes.SHOW_PARTNER_SUCCESS_MODAL_FINAL:
            return __assign(__assign({}, state), { step: STEPS.PARTNER_SUCCESS_MODAL_FINAL });
        case actionTypes.INIT_ADBLOCK_DETECTION:
            return __assign(__assign({}, state), { isAdblockActive: action.payload });
        case actionTypes.CLEAR_PARTNER_DATA:
            return __assign(__assign({}, state), { partnerName: null, promotionId: null, partnerData: null, promotionData: null, loadedData: null });
        case actionTypes.FETCH_USER_DATA_REQUEST:
            return __assign(__assign({}, state), { loading: true, error: false, userData: null });
        case actionTypes.FETCH_USER_DATA_SUCCESS:
            return __assign(__assign({}, state), { loading: false, error: false, userData: action.payload });
        case actionTypes.FETCH_USER_DATA_FAILURE:
            return __assign(__assign({}, state), { loading: false, error: true, userData: null });
        default:
            return state;
    }
}

var logger = getLogger('crewPartnerModal');
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
var initialAction = function (watchContext) { return function () {
    if (watchContext) {
        logger.debug('initialAction triggered');
    }
}; };

var crewPartnerModalModule = {
    containers: containers,
    actions: actions,
    constants: constants,
    reducer: reducer,
    initalAction: initialAction,
    actionTypes: actionTypes,
};

export { crewPartnerModalModule as default };
